export const SCALE_SCL90 = {
  "id": "59487c7badbe1d000c440434",
  "name": "SCL-90",
  "group": null,
  "isStandard": true,
  "headers": [
      {
          "text": "无",
          "score": 0,
          "position": 0,
          "remarks": null,
          "isPositive": false
      },
      {
          "text": "轻度",
          "score": 1,
          "position": 1,
          "remarks": null,
          "isPositive": false
      },
      {
          "text": "中度",
          "score": 2,
          "position": 2,
          "remarks": null,
          "isPositive": false
      },
      {
          "text": "相当重",
          "score": 3,
          "position": 3,
          "remarks": null,
          "isPositive": false
      },
      {
          "text": "严重",
          "score": 4,
          "position": 4,
          "remarks": null,
          "isPositive": false
      }
  ],
  "items": [
      {
          "text": "头痛",
          "weight": 1,
          "values": [
              {
                  "text": "无",
                  "score": 0,
                  "position": 0,
                  "remarks": null,
                  "isPositive": false
              },
              {
                  "text": "轻度",
                  "score": 1,
                  "position": 1,
                  "remarks": null,
                  "isPositive": false
              },
              {
                  "text": "中度",
                  "score": 2,
                  "position": 2,
                  "remarks": null,
                  "isPositive": false
              },
              {
                  "text": "相当重",
                  "score": 3,
                  "position": 3,
                  "remarks": null,
                  "isPositive": false
              },
              {
                  "text": "严重",
                  "score": 4,
                  "position": 4,
                  "remarks": null,
                  "isPositive": false
              }
          ]
      },
      {
          "text": "神经过敏，心中不踏实",
          "weight": 1,
          "values": [
              {
                  "text": "无",
                  "score": 0,
                  "position": 0,
                  "remarks": null,
                  "isPositive": false
              },
              {
                  "text": "轻度",
                  "score": 1,
                  "position": 1,
                  "remarks": null,
                  "isPositive": false
              },
              {
                  "text": "中度",
                  "score": 2,
                  "position": 2,
                  "remarks": null,
                  "isPositive": false
              },
              {
                  "text": "相当重",
                  "score": 3,
                  "position": 3,
                  "remarks": null,
                  "isPositive": false
              },
              {
                  "text": "严重",
                  "score": 4,
                  "position": 4,
                  "remarks": null,
                  "isPositive": false
              }
          ]
      },
      {
          "text": "头脑中有不必要的想法或字句盘旋",
          "weight": 1,
          "values": [
              {
                  "text": "无",
                  "score": 0,
                  "position": 0,
                  "remarks": null,
                  "isPositive": false
              },
              {
                  "text": "轻度",
                  "score": 1,
                  "position": 1,
                  "remarks": null,
                  "isPositive": false
              },
              {
                  "text": "中度",
                  "score": 2,
                  "position": 2,
                  "remarks": null,
                  "isPositive": false
              },
              {
                  "text": "相当重",
                  "score": 3,
                  "position": 3,
                  "remarks": null,
                  "isPositive": false
              },
              {
                  "text": "严重",
                  "score": 4,
                  "position": 4,
                  "remarks": null,
                  "isPositive": false
              }
          ]
      },
      {
          "text": "头昏或昏倒",
          "weight": 1,
          "values": [
              {
                  "text": "无",
                  "score": 0,
                  "position": 0,
                  "remarks": null,
                  "isPositive": false
              },
              {
                  "text": "轻度",
                  "score": 1,
                  "position": 1,
                  "remarks": null,
                  "isPositive": false
              },
              {
                  "text": "中度",
                  "score": 2,
                  "position": 2,
                  "remarks": null,
                  "isPositive": false
              },
              {
                  "text": "相当重",
                  "score": 3,
                  "position": 3,
                  "remarks": null,
                  "isPositive": false
              },
              {
                  "text": "严重",
                  "score": 4,
                  "position": 4,
                  "remarks": null,
                  "isPositive": false
              }
          ]
      },
      {
          "text": "对异性的兴趣减退",
          "weight": 1,
          "values": [
              {
                  "text": "无",
                  "score": 0,
                  "position": 0,
                  "remarks": null,
                  "isPositive": false
              },
              {
                  "text": "轻度",
                  "score": 1,
                  "position": 1,
                  "remarks": null,
                  "isPositive": false
              },
              {
                  "text": "中度",
                  "score": 2,
                  "position": 2,
                  "remarks": null,
                  "isPositive": false
              },
              {
                  "text": "相当重",
                  "score": 3,
                  "position": 3,
                  "remarks": null,
                  "isPositive": false
              },
              {
                  "text": "严重",
                  "score": 4,
                  "position": 4,
                  "remarks": null,
                  "isPositive": false
              }
          ]
      },
      {
          "text": "对旁人责备求全",
          "weight": 1,
          "values": [
              {
                  "text": "无",
                  "score": 0,
                  "position": 0,
                  "remarks": null,
                  "isPositive": false
              },
              {
                  "text": "轻度",
                  "score": 1,
                  "position": 1,
                  "remarks": null,
                  "isPositive": false
              },
              {
                  "text": "中度",
                  "score": 2,
                  "position": 2,
                  "remarks": null,
                  "isPositive": false
              },
              {
                  "text": "相当重",
                  "score": 3,
                  "position": 3,
                  "remarks": null,
                  "isPositive": false
              },
              {
                  "text": "严重",
                  "score": 4,
                  "position": 4,
                  "remarks": null,
                  "isPositive": false
              }
          ]
      },
      {
          "text": "感到别人能控制您的思想",
          "weight": 1,
          "values": [
              {
                  "text": "无",
                  "score": 0,
                  "position": 0,
                  "remarks": null,
                  "isPositive": false
              },
              {
                  "text": "轻度",
                  "score": 1,
                  "position": 1,
                  "remarks": null,
                  "isPositive": false
              },
              {
                  "text": "中度",
                  "score": 2,
                  "position": 2,
                  "remarks": null,
                  "isPositive": false
              },
              {
                  "text": "相当重",
                  "score": 3,
                  "position": 3,
                  "remarks": null,
                  "isPositive": false
              },
              {
                  "text": "严重",
                  "score": 4,
                  "position": 4,
                  "remarks": null,
                  "isPositive": false
              }
          ]
      },
      {
          "text": "责怪别人制造麻烦",
          "weight": 1,
          "values": [
              {
                  "text": "无",
                  "score": 0,
                  "position": 0,
                  "remarks": null,
                  "isPositive": false
              },
              {
                  "text": "轻度",
                  "score": 1,
                  "position": 1,
                  "remarks": null,
                  "isPositive": false
              },
              {
                  "text": "中度",
                  "score": 2,
                  "position": 2,
                  "remarks": null,
                  "isPositive": false
              },
              {
                  "text": "相当重",
                  "score": 3,
                  "position": 3,
                  "remarks": null,
                  "isPositive": false
              },
              {
                  "text": "严重",
                  "score": 4,
                  "position": 4,
                  "remarks": null,
                  "isPositive": false
              }
          ]
      },
      {
          "text": "忘性大",
          "weight": 1,
          "values": [
              {
                  "text": "无",
                  "score": 0,
                  "position": 0,
                  "remarks": null,
                  "isPositive": false
              },
              {
                  "text": "轻度",
                  "score": 1,
                  "position": 1,
                  "remarks": null,
                  "isPositive": false
              },
              {
                  "text": "中度",
                  "score": 2,
                  "position": 2,
                  "remarks": null,
                  "isPositive": false
              },
              {
                  "text": "相当重",
                  "score": 3,
                  "position": 3,
                  "remarks": null,
                  "isPositive": false
              },
              {
                  "text": "严重",
                  "score": 4,
                  "position": 4,
                  "remarks": null,
                  "isPositive": false
              }
          ]
      },
      {
          "text": "担心自己的衣饰整齐及仪态的端正",
          "weight": 1,
          "values": [
              {
                  "text": "无",
                  "score": 0,
                  "position": 0,
                  "remarks": null,
                  "isPositive": false
              },
              {
                  "text": "轻度",
                  "score": 1,
                  "position": 1,
                  "remarks": null,
                  "isPositive": false
              },
              {
                  "text": "中度",
                  "score": 2,
                  "position": 2,
                  "remarks": null,
                  "isPositive": false
              },
              {
                  "text": "相当重",
                  "score": 3,
                  "position": 3,
                  "remarks": null,
                  "isPositive": false
              },
              {
                  "text": "严重",
                  "score": 4,
                  "position": 4,
                  "remarks": null,
                  "isPositive": false
              }
          ]
      },
      {
          "text": "容易烦恼和激动",
          "weight": 1,
          "values": [
              {
                  "text": "无",
                  "score": 0,
                  "position": 0,
                  "remarks": null,
                  "isPositive": false
              },
              {
                  "text": "轻度",
                  "score": 1,
                  "position": 1,
                  "remarks": null,
                  "isPositive": false
              },
              {
                  "text": "中度",
                  "score": 2,
                  "position": 2,
                  "remarks": null,
                  "isPositive": false
              },
              {
                  "text": "相当重",
                  "score": 3,
                  "position": 3,
                  "remarks": null,
                  "isPositive": false
              },
              {
                  "text": "严重",
                  "score": 4,
                  "position": 4,
                  "remarks": null,
                  "isPositive": false
              }
          ]
      },
      {
          "text": "胸痛",
          "weight": 1,
          "values": [
              {
                  "text": "无",
                  "score": 0,
                  "position": 0,
                  "remarks": null,
                  "isPositive": false
              },
              {
                  "text": "轻度",
                  "score": 1,
                  "position": 1,
                  "remarks": null,
                  "isPositive": false
              },
              {
                  "text": "中度",
                  "score": 2,
                  "position": 2,
                  "remarks": null,
                  "isPositive": false
              },
              {
                  "text": "相当重",
                  "score": 3,
                  "position": 3,
                  "remarks": null,
                  "isPositive": false
              },
              {
                  "text": "严重",
                  "score": 4,
                  "position": 4,
                  "remarks": null,
                  "isPositive": false
              }
          ]
      },
      {
          "text": "害怕空旷的场所或街道",
          "weight": 1,
          "values": [
              {
                  "text": "无",
                  "score": 0,
                  "position": 0,
                  "remarks": null,
                  "isPositive": false
              },
              {
                  "text": "轻度",
                  "score": 1,
                  "position": 1,
                  "remarks": null,
                  "isPositive": false
              },
              {
                  "text": "中度",
                  "score": 2,
                  "position": 2,
                  "remarks": null,
                  "isPositive": false
              },
              {
                  "text": "相当重",
                  "score": 3,
                  "position": 3,
                  "remarks": null,
                  "isPositive": false
              },
              {
                  "text": "严重",
                  "score": 4,
                  "position": 4,
                  "remarks": null,
                  "isPositive": false
              }
          ]
      },
      {
          "text": "感到自己的精力下降，活动减慢",
          "weight": 1,
          "values": [
              {
                  "text": "无",
                  "score": 0,
                  "position": 0,
                  "remarks": null,
                  "isPositive": false
              },
              {
                  "text": "轻度",
                  "score": 1,
                  "position": 1,
                  "remarks": null,
                  "isPositive": false
              },
              {
                  "text": "中度",
                  "score": 2,
                  "position": 2,
                  "remarks": null,
                  "isPositive": false
              },
              {
                  "text": "相当重",
                  "score": 3,
                  "position": 3,
                  "remarks": null,
                  "isPositive": false
              },
              {
                  "text": "严重",
                  "score": 4,
                  "position": 4,
                  "remarks": null,
                  "isPositive": false
              }
          ]
      },
      {
          "text": "想结束自己的生命",
          "weight": 1,
          "values": [
              {
                  "text": "无",
                  "score": 0,
                  "position": 0,
                  "remarks": null,
                  "isPositive": false
              },
              {
                  "text": "轻度",
                  "score": 1,
                  "position": 1,
                  "remarks": null,
                  "isPositive": false
              },
              {
                  "text": "中度",
                  "score": 2,
                  "position": 2,
                  "remarks": null,
                  "isPositive": false
              },
              {
                  "text": "相当重",
                  "score": 3,
                  "position": 3,
                  "remarks": null,
                  "isPositive": false
              },
              {
                  "text": "严重",
                  "score": 4,
                  "position": 4,
                  "remarks": null,
                  "isPositive": false
              }
          ]
      },
      {
          "text": "听到旁人听不到的声音",
          "weight": 1,
          "values": [
              {
                  "text": "无",
                  "score": 0,
                  "position": 0,
                  "remarks": null,
                  "isPositive": false
              },
              {
                  "text": "轻度",
                  "score": 1,
                  "position": 1,
                  "remarks": null,
                  "isPositive": false
              },
              {
                  "text": "中度",
                  "score": 2,
                  "position": 2,
                  "remarks": null,
                  "isPositive": false
              },
              {
                  "text": "相当重",
                  "score": 3,
                  "position": 3,
                  "remarks": null,
                  "isPositive": false
              },
              {
                  "text": "严重",
                  "score": 4,
                  "position": 4,
                  "remarks": null,
                  "isPositive": false
              }
          ]
      },
      {
          "text": "发抖",
          "weight": 1,
          "values": [
              {
                  "text": "无",
                  "score": 0,
                  "position": 0,
                  "remarks": null,
                  "isPositive": false
              },
              {
                  "text": "轻度",
                  "score": 1,
                  "position": 1,
                  "remarks": null,
                  "isPositive": false
              },
              {
                  "text": "中度",
                  "score": 2,
                  "position": 2,
                  "remarks": null,
                  "isPositive": false
              },
              {
                  "text": "相当重",
                  "score": 3,
                  "position": 3,
                  "remarks": null,
                  "isPositive": false
              },
              {
                  "text": "严重",
                  "score": 4,
                  "position": 4,
                  "remarks": null,
                  "isPositive": false
              }
          ]
      },
      {
          "text": "感到大多数人都不可信任",
          "weight": 1,
          "values": [
              {
                  "text": "无",
                  "score": 0,
                  "position": 0,
                  "remarks": null,
                  "isPositive": false
              },
              {
                  "text": "轻度",
                  "score": 1,
                  "position": 1,
                  "remarks": null,
                  "isPositive": false
              },
              {
                  "text": "中度",
                  "score": 2,
                  "position": 2,
                  "remarks": null,
                  "isPositive": false
              },
              {
                  "text": "相当重",
                  "score": 3,
                  "position": 3,
                  "remarks": null,
                  "isPositive": false
              },
              {
                  "text": "严重",
                  "score": 4,
                  "position": 4,
                  "remarks": null,
                  "isPositive": false
              }
          ]
      },
      {
          "text": "胃口不好",
          "weight": 1,
          "values": [
              {
                  "text": "无",
                  "score": 0,
                  "position": 0,
                  "remarks": null,
                  "isPositive": false
              },
              {
                  "text": "轻度",
                  "score": 1,
                  "position": 1,
                  "remarks": null,
                  "isPositive": false
              },
              {
                  "text": "中度",
                  "score": 2,
                  "position": 2,
                  "remarks": null,
                  "isPositive": false
              },
              {
                  "text": "相当重",
                  "score": 3,
                  "position": 3,
                  "remarks": null,
                  "isPositive": false
              },
              {
                  "text": "严重",
                  "score": 4,
                  "position": 4,
                  "remarks": null,
                  "isPositive": false
              }
          ]
      },
      {
          "text": "容易哭泣",
          "weight": 1,
          "values": [
              {
                  "text": "无",
                  "score": 0,
                  "position": 0,
                  "remarks": null,
                  "isPositive": false
              },
              {
                  "text": "轻度",
                  "score": 1,
                  "position": 1,
                  "remarks": null,
                  "isPositive": false
              },
              {
                  "text": "中度",
                  "score": 2,
                  "position": 2,
                  "remarks": null,
                  "isPositive": false
              },
              {
                  "text": "相当重",
                  "score": 3,
                  "position": 3,
                  "remarks": null,
                  "isPositive": false
              },
              {
                  "text": "严重",
                  "score": 4,
                  "position": 4,
                  "remarks": null,
                  "isPositive": false
              }
          ]
      },
      {
          "text": "同异性相处时感到害羞不自在",
          "weight": 1,
          "values": [
              {
                  "text": "无",
                  "score": 0,
                  "position": 0,
                  "remarks": null,
                  "isPositive": false
              },
              {
                  "text": "轻度",
                  "score": 1,
                  "position": 1,
                  "remarks": null,
                  "isPositive": false
              },
              {
                  "text": "中度",
                  "score": 2,
                  "position": 2,
                  "remarks": null,
                  "isPositive": false
              },
              {
                  "text": "相当重",
                  "score": 3,
                  "position": 3,
                  "remarks": null,
                  "isPositive": false
              },
              {
                  "text": "严重",
                  "score": 4,
                  "position": 4,
                  "remarks": null,
                  "isPositive": false
              }
          ]
      },
      {
          "text": "感到受骗，中了圈套或有人想抓住您",
          "weight": 1,
          "values": [
              {
                  "text": "无",
                  "score": 0,
                  "position": 0,
                  "remarks": null,
                  "isPositive": false
              },
              {
                  "text": "轻度",
                  "score": 1,
                  "position": 1,
                  "remarks": null,
                  "isPositive": false
              },
              {
                  "text": "中度",
                  "score": 2,
                  "position": 2,
                  "remarks": null,
                  "isPositive": false
              },
              {
                  "text": "相当重",
                  "score": 3,
                  "position": 3,
                  "remarks": null,
                  "isPositive": false
              },
              {
                  "text": "严重",
                  "score": 4,
                  "position": 4,
                  "remarks": null,
                  "isPositive": false
              }
          ]
      },
      {
          "text": "无缘无故地突然感到害怕",
          "weight": 1,
          "values": [
              {
                  "text": "无",
                  "score": 0,
                  "position": 0,
                  "remarks": null,
                  "isPositive": false
              },
              {
                  "text": "轻度",
                  "score": 1,
                  "position": 1,
                  "remarks": null,
                  "isPositive": false
              },
              {
                  "text": "中度",
                  "score": 2,
                  "position": 2,
                  "remarks": null,
                  "isPositive": false
              },
              {
                  "text": "相当重",
                  "score": 3,
                  "position": 3,
                  "remarks": null,
                  "isPositive": false
              },
              {
                  "text": "严重",
                  "score": 4,
                  "position": 4,
                  "remarks": null,
                  "isPositive": false
              }
          ]
      },
      {
          "text": "自己不能控制地大发脾气",
          "weight": 1,
          "values": [
              {
                  "text": "无",
                  "score": 0,
                  "position": 0,
                  "remarks": null,
                  "isPositive": false
              },
              {
                  "text": "轻度",
                  "score": 1,
                  "position": 1,
                  "remarks": null,
                  "isPositive": false
              },
              {
                  "text": "中度",
                  "score": 2,
                  "position": 2,
                  "remarks": null,
                  "isPositive": false
              },
              {
                  "text": "相当重",
                  "score": 3,
                  "position": 3,
                  "remarks": null,
                  "isPositive": false
              },
              {
                  "text": "严重",
                  "score": 4,
                  "position": 4,
                  "remarks": null,
                  "isPositive": false
              }
          ]
      },
      {
          "text": "怕单独出门",
          "weight": 1,
          "values": [
              {
                  "text": "无",
                  "score": 0,
                  "position": 0,
                  "remarks": null,
                  "isPositive": false
              },
              {
                  "text": "轻度",
                  "score": 1,
                  "position": 1,
                  "remarks": null,
                  "isPositive": false
              },
              {
                  "text": "中度",
                  "score": 2,
                  "position": 2,
                  "remarks": null,
                  "isPositive": false
              },
              {
                  "text": "相当重",
                  "score": 3,
                  "position": 3,
                  "remarks": null,
                  "isPositive": false
              },
              {
                  "text": "严重",
                  "score": 4,
                  "position": 4,
                  "remarks": null,
                  "isPositive": false
              }
          ]
      },
      {
          "text": "经常责怪自己",
          "weight": 1,
          "values": [
              {
                  "text": "无",
                  "score": 0,
                  "position": 0,
                  "remarks": null,
                  "isPositive": false
              },
              {
                  "text": "轻度",
                  "score": 1,
                  "position": 1,
                  "remarks": null,
                  "isPositive": false
              },
              {
                  "text": "中度",
                  "score": 2,
                  "position": 2,
                  "remarks": null,
                  "isPositive": false
              },
              {
                  "text": "相当重",
                  "score": 3,
                  "position": 3,
                  "remarks": null,
                  "isPositive": false
              },
              {
                  "text": "严重",
                  "score": 4,
                  "position": 4,
                  "remarks": null,
                  "isPositive": false
              }
          ]
      },
      {
          "text": "腰痛",
          "weight": 1,
          "values": [
              {
                  "text": "无",
                  "score": 0,
                  "position": 0,
                  "remarks": null,
                  "isPositive": false
              },
              {
                  "text": "轻度",
                  "score": 1,
                  "position": 1,
                  "remarks": null,
                  "isPositive": false
              },
              {
                  "text": "中度",
                  "score": 2,
                  "position": 2,
                  "remarks": null,
                  "isPositive": false
              },
              {
                  "text": "相当重",
                  "score": 3,
                  "position": 3,
                  "remarks": null,
                  "isPositive": false
              },
              {
                  "text": "严重",
                  "score": 4,
                  "position": 4,
                  "remarks": null,
                  "isPositive": false
              }
          ]
      },
      {
          "text": "感到难以完成任务",
          "weight": 1,
          "values": [
              {
                  "text": "无",
                  "score": 0,
                  "position": 0,
                  "remarks": null,
                  "isPositive": false
              },
              {
                  "text": "轻度",
                  "score": 1,
                  "position": 1,
                  "remarks": null,
                  "isPositive": false
              },
              {
                  "text": "中度",
                  "score": 2,
                  "position": 2,
                  "remarks": null,
                  "isPositive": false
              },
              {
                  "text": "相当重",
                  "score": 3,
                  "position": 3,
                  "remarks": null,
                  "isPositive": false
              },
              {
                  "text": "严重",
                  "score": 4,
                  "position": 4,
                  "remarks": null,
                  "isPositive": false
              }
          ]
      },
      {
          "text": "感到孤独",
          "weight": 1,
          "values": [
              {
                  "text": "无",
                  "score": 0,
                  "position": 0,
                  "remarks": null,
                  "isPositive": false
              },
              {
                  "text": "轻度",
                  "score": 1,
                  "position": 1,
                  "remarks": null,
                  "isPositive": false
              },
              {
                  "text": "中度",
                  "score": 2,
                  "position": 2,
                  "remarks": null,
                  "isPositive": false
              },
              {
                  "text": "相当重",
                  "score": 3,
                  "position": 3,
                  "remarks": null,
                  "isPositive": false
              },
              {
                  "text": "严重",
                  "score": 4,
                  "position": 4,
                  "remarks": null,
                  "isPositive": false
              }
          ]
      },
      {
          "text": "感到苦闷",
          "weight": 1,
          "values": [
              {
                  "text": "无",
                  "score": 0,
                  "position": 0,
                  "remarks": null,
                  "isPositive": false
              },
              {
                  "text": "轻度",
                  "score": 1,
                  "position": 1,
                  "remarks": null,
                  "isPositive": false
              },
              {
                  "text": "中度",
                  "score": 2,
                  "position": 2,
                  "remarks": null,
                  "isPositive": false
              },
              {
                  "text": "相当重",
                  "score": 3,
                  "position": 3,
                  "remarks": null,
                  "isPositive": false
              },
              {
                  "text": "严重",
                  "score": 4,
                  "position": 4,
                  "remarks": null,
                  "isPositive": false
              }
          ]
      },
      {
          "text": "过分担忧",
          "weight": 1,
          "values": [
              {
                  "text": "无",
                  "score": 0,
                  "position": 0,
                  "remarks": null,
                  "isPositive": false
              },
              {
                  "text": "轻度",
                  "score": 1,
                  "position": 1,
                  "remarks": null,
                  "isPositive": false
              },
              {
                  "text": "中度",
                  "score": 2,
                  "position": 2,
                  "remarks": null,
                  "isPositive": false
              },
              {
                  "text": "相当重",
                  "score": 3,
                  "position": 3,
                  "remarks": null,
                  "isPositive": false
              },
              {
                  "text": "严重",
                  "score": 4,
                  "position": 4,
                  "remarks": null,
                  "isPositive": false
              }
          ]
      },
      {
          "text": "对事物不感兴趣",
          "weight": 1,
          "values": [
              {
                  "text": "无",
                  "score": 0,
                  "position": 0,
                  "remarks": null,
                  "isPositive": false
              },
              {
                  "text": "轻度",
                  "score": 1,
                  "position": 1,
                  "remarks": null,
                  "isPositive": false
              },
              {
                  "text": "中度",
                  "score": 2,
                  "position": 2,
                  "remarks": null,
                  "isPositive": false
              },
              {
                  "text": "相当重",
                  "score": 3,
                  "position": 3,
                  "remarks": null,
                  "isPositive": false
              },
              {
                  "text": "严重",
                  "score": 4,
                  "position": 4,
                  "remarks": null,
                  "isPositive": false
              }
          ]
      },
      {
          "text": "感到害怕",
          "weight": 1,
          "values": [
              {
                  "text": "无",
                  "score": 0,
                  "position": 0,
                  "remarks": null,
                  "isPositive": false
              },
              {
                  "text": "轻度",
                  "score": 1,
                  "position": 1,
                  "remarks": null,
                  "isPositive": false
              },
              {
                  "text": "中度",
                  "score": 2,
                  "position": 2,
                  "remarks": null,
                  "isPositive": false
              },
              {
                  "text": "相当重",
                  "score": 3,
                  "position": 3,
                  "remarks": null,
                  "isPositive": false
              },
              {
                  "text": "严重",
                  "score": 4,
                  "position": 4,
                  "remarks": null,
                  "isPositive": false
              }
          ]
      },
      {
          "text": "您的感情容易受到伤害",
          "weight": 1,
          "values": [
              {
                  "text": "无",
                  "score": 0,
                  "position": 0,
                  "remarks": null,
                  "isPositive": false
              },
              {
                  "text": "轻度",
                  "score": 1,
                  "position": 1,
                  "remarks": null,
                  "isPositive": false
              },
              {
                  "text": "中度",
                  "score": 2,
                  "position": 2,
                  "remarks": null,
                  "isPositive": false
              },
              {
                  "text": "相当重",
                  "score": 3,
                  "position": 3,
                  "remarks": null,
                  "isPositive": false
              },
              {
                  "text": "严重",
                  "score": 4,
                  "position": 4,
                  "remarks": null,
                  "isPositive": false
              }
          ]
      },
      {
          "text": "旁人能知道您的私下想法",
          "weight": 1,
          "values": [
              {
                  "text": "无",
                  "score": 0,
                  "position": 0,
                  "remarks": null,
                  "isPositive": false
              },
              {
                  "text": "轻度",
                  "score": 1,
                  "position": 1,
                  "remarks": null,
                  "isPositive": false
              },
              {
                  "text": "中度",
                  "score": 2,
                  "position": 2,
                  "remarks": null,
                  "isPositive": false
              },
              {
                  "text": "相当重",
                  "score": 3,
                  "position": 3,
                  "remarks": null,
                  "isPositive": false
              },
              {
                  "text": "严重",
                  "score": 4,
                  "position": 4,
                  "remarks": null,
                  "isPositive": false
              }
          ]
      },
      {
          "text": "感到别人不理解您、不同情您",
          "weight": 1,
          "values": [
              {
                  "text": "无",
                  "score": 0,
                  "position": 0,
                  "remarks": null,
                  "isPositive": false
              },
              {
                  "text": "轻度",
                  "score": 1,
                  "position": 1,
                  "remarks": null,
                  "isPositive": false
              },
              {
                  "text": "中度",
                  "score": 2,
                  "position": 2,
                  "remarks": null,
                  "isPositive": false
              },
              {
                  "text": "相当重",
                  "score": 3,
                  "position": 3,
                  "remarks": null,
                  "isPositive": false
              },
              {
                  "text": "严重",
                  "score": 4,
                  "position": 4,
                  "remarks": null,
                  "isPositive": false
              }
          ]
      },
      {
          "text": "感到人们对您不友好，不喜欢您",
          "weight": 1,
          "values": [
              {
                  "text": "无",
                  "score": 0,
                  "position": 0,
                  "remarks": null,
                  "isPositive": false
              },
              {
                  "text": "轻度",
                  "score": 1,
                  "position": 1,
                  "remarks": null,
                  "isPositive": false
              },
              {
                  "text": "中度",
                  "score": 2,
                  "position": 2,
                  "remarks": null,
                  "isPositive": false
              },
              {
                  "text": "相当重",
                  "score": 3,
                  "position": 3,
                  "remarks": null,
                  "isPositive": false
              },
              {
                  "text": "严重",
                  "score": 4,
                  "position": 4,
                  "remarks": null,
                  "isPositive": false
              }
          ]
      },
      {
          "text": "做事必须做得很慢以保证做得正确",
          "weight": 1,
          "values": [
              {
                  "text": "无",
                  "score": 0,
                  "position": 0,
                  "remarks": null,
                  "isPositive": false
              },
              {
                  "text": "轻度",
                  "score": 1,
                  "position": 1,
                  "remarks": null,
                  "isPositive": false
              },
              {
                  "text": "中度",
                  "score": 2,
                  "position": 2,
                  "remarks": null,
                  "isPositive": false
              },
              {
                  "text": "相当重",
                  "score": 3,
                  "position": 3,
                  "remarks": null,
                  "isPositive": false
              },
              {
                  "text": "严重",
                  "score": 4,
                  "position": 4,
                  "remarks": null,
                  "isPositive": false
              }
          ]
      },
      {
          "text": "心跳得很厉害",
          "weight": 1,
          "values": [
              {
                  "text": "无",
                  "score": 0,
                  "position": 0,
                  "remarks": null,
                  "isPositive": false
              },
              {
                  "text": "轻度",
                  "score": 1,
                  "position": 1,
                  "remarks": null,
                  "isPositive": false
              },
              {
                  "text": "中度",
                  "score": 2,
                  "position": 2,
                  "remarks": null,
                  "isPositive": false
              },
              {
                  "text": "相当重",
                  "score": 3,
                  "position": 3,
                  "remarks": null,
                  "isPositive": false
              },
              {
                  "text": "严重",
                  "score": 4,
                  "position": 4,
                  "remarks": null,
                  "isPositive": false
              }
          ]
      },
      {
          "text": "恶心或胃部不舒服",
          "weight": 1,
          "values": [
              {
                  "text": "无",
                  "score": 0,
                  "position": 0,
                  "remarks": null,
                  "isPositive": false
              },
              {
                  "text": "轻度",
                  "score": 1,
                  "position": 1,
                  "remarks": null,
                  "isPositive": false
              },
              {
                  "text": "中度",
                  "score": 2,
                  "position": 2,
                  "remarks": null,
                  "isPositive": false
              },
              {
                  "text": "相当重",
                  "score": 3,
                  "position": 3,
                  "remarks": null,
                  "isPositive": false
              },
              {
                  "text": "严重",
                  "score": 4,
                  "position": 4,
                  "remarks": null,
                  "isPositive": false
              }
          ]
      },
      {
          "text": "感到比不上他人",
          "weight": 1,
          "values": [
              {
                  "text": "无",
                  "score": 0,
                  "position": 0,
                  "remarks": null,
                  "isPositive": false
              },
              {
                  "text": "轻度",
                  "score": 1,
                  "position": 1,
                  "remarks": null,
                  "isPositive": false
              },
              {
                  "text": "中度",
                  "score": 2,
                  "position": 2,
                  "remarks": null,
                  "isPositive": false
              },
              {
                  "text": "相当重",
                  "score": 3,
                  "position": 3,
                  "remarks": null,
                  "isPositive": false
              },
              {
                  "text": "严重",
                  "score": 4,
                  "position": 4,
                  "remarks": null,
                  "isPositive": false
              }
          ]
      },
      {
          "text": "肌肉酸痛",
          "weight": 1,
          "values": [
              {
                  "text": "无",
                  "score": 0,
                  "position": 0,
                  "remarks": null,
                  "isPositive": false
              },
              {
                  "text": "轻度",
                  "score": 1,
                  "position": 1,
                  "remarks": null,
                  "isPositive": false
              },
              {
                  "text": "中度",
                  "score": 2,
                  "position": 2,
                  "remarks": null,
                  "isPositive": false
              },
              {
                  "text": "相当重",
                  "score": 3,
                  "position": 3,
                  "remarks": null,
                  "isPositive": false
              },
              {
                  "text": "严重",
                  "score": 4,
                  "position": 4,
                  "remarks": null,
                  "isPositive": false
              }
          ]
      },
      {
          "text": "感到有人在监视您、谈论您",
          "weight": 1,
          "values": [
              {
                  "text": "无",
                  "score": 0,
                  "position": 0,
                  "remarks": null,
                  "isPositive": false
              },
              {
                  "text": "轻度",
                  "score": 1,
                  "position": 1,
                  "remarks": null,
                  "isPositive": false
              },
              {
                  "text": "中度",
                  "score": 2,
                  "position": 2,
                  "remarks": null,
                  "isPositive": false
              },
              {
                  "text": "相当重",
                  "score": 3,
                  "position": 3,
                  "remarks": null,
                  "isPositive": false
              },
              {
                  "text": "严重",
                  "score": 4,
                  "position": 4,
                  "remarks": null,
                  "isPositive": false
              }
          ]
      },
      {
          "text": "难以入睡",
          "weight": 1,
          "values": [
              {
                  "text": "无",
                  "score": 0,
                  "position": 0,
                  "remarks": null,
                  "isPositive": false
              },
              {
                  "text": "轻度",
                  "score": 1,
                  "position": 1,
                  "remarks": null,
                  "isPositive": false
              },
              {
                  "text": "中度",
                  "score": 2,
                  "position": 2,
                  "remarks": null,
                  "isPositive": false
              },
              {
                  "text": "相当重",
                  "score": 3,
                  "position": 3,
                  "remarks": null,
                  "isPositive": false
              },
              {
                  "text": "严重",
                  "score": 4,
                  "position": 4,
                  "remarks": null,
                  "isPositive": false
              }
          ]
      },
      {
          "text": "做事必须反复检查",
          "weight": 1,
          "values": [
              {
                  "text": "无",
                  "score": 0,
                  "position": 0,
                  "remarks": null,
                  "isPositive": false
              },
              {
                  "text": "轻度",
                  "score": 1,
                  "position": 1,
                  "remarks": null,
                  "isPositive": false
              },
              {
                  "text": "中度",
                  "score": 2,
                  "position": 2,
                  "remarks": null,
                  "isPositive": false
              },
              {
                  "text": "相当重",
                  "score": 3,
                  "position": 3,
                  "remarks": null,
                  "isPositive": false
              },
              {
                  "text": "严重",
                  "score": 4,
                  "position": 4,
                  "remarks": null,
                  "isPositive": false
              }
          ]
      },
      {
          "text": "难以做出决定",
          "weight": 1,
          "values": [
              {
                  "text": "无",
                  "score": 0,
                  "position": 0,
                  "remarks": null,
                  "isPositive": false
              },
              {
                  "text": "轻度",
                  "score": 1,
                  "position": 1,
                  "remarks": null,
                  "isPositive": false
              },
              {
                  "text": "中度",
                  "score": 2,
                  "position": 2,
                  "remarks": null,
                  "isPositive": false
              },
              {
                  "text": "相当重",
                  "score": 3,
                  "position": 3,
                  "remarks": null,
                  "isPositive": false
              },
              {
                  "text": "严重",
                  "score": 4,
                  "position": 4,
                  "remarks": null,
                  "isPositive": false
              }
          ]
      },
      {
          "text": "怕乘电车、公共汽车、地铁或火车",
          "weight": 1,
          "values": [
              {
                  "text": "无",
                  "score": 0,
                  "position": 0,
                  "remarks": null,
                  "isPositive": false
              },
              {
                  "text": "轻度",
                  "score": 1,
                  "position": 1,
                  "remarks": null,
                  "isPositive": false
              },
              {
                  "text": "中度",
                  "score": 2,
                  "position": 2,
                  "remarks": null,
                  "isPositive": false
              },
              {
                  "text": "相当重",
                  "score": 3,
                  "position": 3,
                  "remarks": null,
                  "isPositive": false
              },
              {
                  "text": "严重",
                  "score": 4,
                  "position": 4,
                  "remarks": null,
                  "isPositive": false
              }
          ]
      },
      {
          "text": "呼吸有困难",
          "weight": 1,
          "values": [
              {
                  "text": "无",
                  "score": 0,
                  "position": 0,
                  "remarks": null,
                  "isPositive": false
              },
              {
                  "text": "轻度",
                  "score": 1,
                  "position": 1,
                  "remarks": null,
                  "isPositive": false
              },
              {
                  "text": "中度",
                  "score": 2,
                  "position": 2,
                  "remarks": null,
                  "isPositive": false
              },
              {
                  "text": "相当重",
                  "score": 3,
                  "position": 3,
                  "remarks": null,
                  "isPositive": false
              },
              {
                  "text": "严重",
                  "score": 4,
                  "position": 4,
                  "remarks": null,
                  "isPositive": false
              }
          ]
      },
      {
          "text": "一阵阵发冷或发热",
          "weight": 1,
          "values": [
              {
                  "text": "无",
                  "score": 0,
                  "position": 0,
                  "remarks": null,
                  "isPositive": false
              },
              {
                  "text": "轻度",
                  "score": 1,
                  "position": 1,
                  "remarks": null,
                  "isPositive": false
              },
              {
                  "text": "中度",
                  "score": 2,
                  "position": 2,
                  "remarks": null,
                  "isPositive": false
              },
              {
                  "text": "相当重",
                  "score": 3,
                  "position": 3,
                  "remarks": null,
                  "isPositive": false
              },
              {
                  "text": "严重",
                  "score": 4,
                  "position": 4,
                  "remarks": null,
                  "isPositive": false
              }
          ]
      },
      {
          "text": "因为感到害怕而避开某些东西、场合或活动",
          "weight": 1,
          "values": [
              {
                  "text": "无",
                  "score": 0,
                  "position": 0,
                  "remarks": null,
                  "isPositive": false
              },
              {
                  "text": "轻度",
                  "score": 1,
                  "position": 1,
                  "remarks": null,
                  "isPositive": false
              },
              {
                  "text": "中度",
                  "score": 2,
                  "position": 2,
                  "remarks": null,
                  "isPositive": false
              },
              {
                  "text": "相当重",
                  "score": 3,
                  "position": 3,
                  "remarks": null,
                  "isPositive": false
              },
              {
                  "text": "严重",
                  "score": 4,
                  "position": 4,
                  "remarks": null,
                  "isPositive": false
              }
          ]
      },
      {
          "text": "脑子变空了",
          "weight": 1,
          "values": [
              {
                  "text": "无",
                  "score": 0,
                  "position": 0,
                  "remarks": null,
                  "isPositive": false
              },
              {
                  "text": "轻度",
                  "score": 1,
                  "position": 1,
                  "remarks": null,
                  "isPositive": false
              },
              {
                  "text": "中度",
                  "score": 2,
                  "position": 2,
                  "remarks": null,
                  "isPositive": false
              },
              {
                  "text": "相当重",
                  "score": 3,
                  "position": 3,
                  "remarks": null,
                  "isPositive": false
              },
              {
                  "text": "严重",
                  "score": 4,
                  "position": 4,
                  "remarks": null,
                  "isPositive": false
              }
          ]
      },
      {
          "text": "身体发麻或刺痛",
          "weight": 1,
          "values": [
              {
                  "text": "无",
                  "score": 0,
                  "position": 0,
                  "remarks": null,
                  "isPositive": false
              },
              {
                  "text": "轻度",
                  "score": 1,
                  "position": 1,
                  "remarks": null,
                  "isPositive": false
              },
              {
                  "text": "中度",
                  "score": 2,
                  "position": 2,
                  "remarks": null,
                  "isPositive": false
              },
              {
                  "text": "相当重",
                  "score": 3,
                  "position": 3,
                  "remarks": null,
                  "isPositive": false
              },
              {
                  "text": "严重",
                  "score": 4,
                  "position": 4,
                  "remarks": null,
                  "isPositive": false
              }
          ]
      },
      {
          "text": "喉咙有梗塞感",
          "weight": 1,
          "values": [
              {
                  "text": "无",
                  "score": 0,
                  "position": 0,
                  "remarks": null,
                  "isPositive": false
              },
              {
                  "text": "轻度",
                  "score": 1,
                  "position": 1,
                  "remarks": null,
                  "isPositive": false
              },
              {
                  "text": "中度",
                  "score": 2,
                  "position": 2,
                  "remarks": null,
                  "isPositive": false
              },
              {
                  "text": "相当重",
                  "score": 3,
                  "position": 3,
                  "remarks": null,
                  "isPositive": false
              },
              {
                  "text": "严重",
                  "score": 4,
                  "position": 4,
                  "remarks": null,
                  "isPositive": false
              }
          ]
      },
      {
          "text": "感到前途没有希望",
          "weight": 1,
          "values": [
              {
                  "text": "无",
                  "score": 0,
                  "position": 0,
                  "remarks": null,
                  "isPositive": false
              },
              {
                  "text": "轻度",
                  "score": 1,
                  "position": 1,
                  "remarks": null,
                  "isPositive": false
              },
              {
                  "text": "中度",
                  "score": 2,
                  "position": 2,
                  "remarks": null,
                  "isPositive": false
              },
              {
                  "text": "相当重",
                  "score": 3,
                  "position": 3,
                  "remarks": null,
                  "isPositive": false
              },
              {
                  "text": "严重",
                  "score": 4,
                  "position": 4,
                  "remarks": null,
                  "isPositive": false
              }
          ]
      },
      {
          "text": "不能集中注意力",
          "weight": 1,
          "values": [
              {
                  "text": "无",
                  "score": 0,
                  "position": 0,
                  "remarks": null,
                  "isPositive": false
              },
              {
                  "text": "轻度",
                  "score": 1,
                  "position": 1,
                  "remarks": null,
                  "isPositive": false
              },
              {
                  "text": "中度",
                  "score": 2,
                  "position": 2,
                  "remarks": null,
                  "isPositive": false
              },
              {
                  "text": "相当重",
                  "score": 3,
                  "position": 3,
                  "remarks": null,
                  "isPositive": false
              },
              {
                  "text": "严重",
                  "score": 4,
                  "position": 4,
                  "remarks": null,
                  "isPositive": false
              }
          ]
      },
      {
          "text": "感到身体的某一部分软弱无力",
          "weight": 1,
          "values": [
              {
                  "text": "无",
                  "score": 0,
                  "position": 0,
                  "remarks": null,
                  "isPositive": false
              },
              {
                  "text": "轻度",
                  "score": 1,
                  "position": 1,
                  "remarks": null,
                  "isPositive": false
              },
              {
                  "text": "中度",
                  "score": 2,
                  "position": 2,
                  "remarks": null,
                  "isPositive": false
              },
              {
                  "text": "相当重",
                  "score": 3,
                  "position": 3,
                  "remarks": null,
                  "isPositive": false
              },
              {
                  "text": "严重",
                  "score": 4,
                  "position": 4,
                  "remarks": null,
                  "isPositive": false
              }
          ]
      },
      {
          "text": "感到紧张或容易紧张",
          "weight": 1,
          "values": [
              {
                  "text": "无",
                  "score": 0,
                  "position": 0,
                  "remarks": null,
                  "isPositive": false
              },
              {
                  "text": "轻度",
                  "score": 1,
                  "position": 1,
                  "remarks": null,
                  "isPositive": false
              },
              {
                  "text": "中度",
                  "score": 2,
                  "position": 2,
                  "remarks": null,
                  "isPositive": false
              },
              {
                  "text": "相当重",
                  "score": 3,
                  "position": 3,
                  "remarks": null,
                  "isPositive": false
              },
              {
                  "text": "严重",
                  "score": 4,
                  "position": 4,
                  "remarks": null,
                  "isPositive": false
              }
          ]
      },
      {
          "text": "感到手或脚发重",
          "weight": 1,
          "values": [
              {
                  "text": "无",
                  "score": 0,
                  "position": 0,
                  "remarks": null,
                  "isPositive": false
              },
              {
                  "text": "轻度",
                  "score": 1,
                  "position": 1,
                  "remarks": null,
                  "isPositive": false
              },
              {
                  "text": "中度",
                  "score": 2,
                  "position": 2,
                  "remarks": null,
                  "isPositive": false
              },
              {
                  "text": "相当重",
                  "score": 3,
                  "position": 3,
                  "remarks": null,
                  "isPositive": false
              },
              {
                  "text": "严重",
                  "score": 4,
                  "position": 4,
                  "remarks": null,
                  "isPositive": false
              }
          ]
      },
      {
          "text": "想到死亡的事",
          "weight": 1,
          "values": [
              {
                  "text": "无",
                  "score": 0,
                  "position": 0,
                  "remarks": null,
                  "isPositive": false
              },
              {
                  "text": "轻度",
                  "score": 1,
                  "position": 1,
                  "remarks": null,
                  "isPositive": false
              },
              {
                  "text": "中度",
                  "score": 2,
                  "position": 2,
                  "remarks": null,
                  "isPositive": false
              },
              {
                  "text": "相当重",
                  "score": 3,
                  "position": 3,
                  "remarks": null,
                  "isPositive": false
              },
              {
                  "text": "严重",
                  "score": 4,
                  "position": 4,
                  "remarks": null,
                  "isPositive": false
              }
          ]
      },
      {
          "text": "吃得太多",
          "weight": 1,
          "values": [
              {
                  "text": "无",
                  "score": 0,
                  "position": 0,
                  "remarks": null,
                  "isPositive": false
              },
              {
                  "text": "轻度",
                  "score": 1,
                  "position": 1,
                  "remarks": null,
                  "isPositive": false
              },
              {
                  "text": "中度",
                  "score": 2,
                  "position": 2,
                  "remarks": null,
                  "isPositive": false
              },
              {
                  "text": "相当重",
                  "score": 3,
                  "position": 3,
                  "remarks": null,
                  "isPositive": false
              },
              {
                  "text": "严重",
                  "score": 4,
                  "position": 4,
                  "remarks": null,
                  "isPositive": false
              }
          ]
      },
      {
          "text": "当别人看着您或谈论您时感到不自在",
          "weight": 1,
          "values": [
              {
                  "text": "无",
                  "score": 0,
                  "position": 0,
                  "remarks": null,
                  "isPositive": false
              },
              {
                  "text": "轻度",
                  "score": 1,
                  "position": 1,
                  "remarks": null,
                  "isPositive": false
              },
              {
                  "text": "中度",
                  "score": 2,
                  "position": 2,
                  "remarks": null,
                  "isPositive": false
              },
              {
                  "text": "相当重",
                  "score": 3,
                  "position": 3,
                  "remarks": null,
                  "isPositive": false
              },
              {
                  "text": "严重",
                  "score": 4,
                  "position": 4,
                  "remarks": null,
                  "isPositive": false
              }
          ]
      },
      {
          "text": "有一些不属于您自己的想法",
          "weight": 1,
          "values": [
              {
                  "text": "无",
                  "score": 0,
                  "position": 0,
                  "remarks": null,
                  "isPositive": false
              },
              {
                  "text": "轻度",
                  "score": 1,
                  "position": 1,
                  "remarks": null,
                  "isPositive": false
              },
              {
                  "text": "中度",
                  "score": 2,
                  "position": 2,
                  "remarks": null,
                  "isPositive": false
              },
              {
                  "text": "相当重",
                  "score": 3,
                  "position": 3,
                  "remarks": null,
                  "isPositive": false
              },
              {
                  "text": "严重",
                  "score": 4,
                  "position": 4,
                  "remarks": null,
                  "isPositive": false
              }
          ]
      },
      {
          "text": "有想打人或伤害他人的冲动",
          "weight": 1,
          "values": [
              {
                  "text": "无",
                  "score": 0,
                  "position": 0,
                  "remarks": null,
                  "isPositive": false
              },
              {
                  "text": "轻度",
                  "score": 1,
                  "position": 1,
                  "remarks": null,
                  "isPositive": false
              },
              {
                  "text": "中度",
                  "score": 2,
                  "position": 2,
                  "remarks": null,
                  "isPositive": false
              },
              {
                  "text": "相当重",
                  "score": 3,
                  "position": 3,
                  "remarks": null,
                  "isPositive": false
              },
              {
                  "text": "严重",
                  "score": 4,
                  "position": 4,
                  "remarks": null,
                  "isPositive": false
              }
          ]
      },
      {
          "text": "醒得太早",
          "weight": 1,
          "values": [
              {
                  "text": "无",
                  "score": 0,
                  "position": 0,
                  "remarks": null,
                  "isPositive": false
              },
              {
                  "text": "轻度",
                  "score": 1,
                  "position": 1,
                  "remarks": null,
                  "isPositive": false
              },
              {
                  "text": "中度",
                  "score": 2,
                  "position": 2,
                  "remarks": null,
                  "isPositive": false
              },
              {
                  "text": "相当重",
                  "score": 3,
                  "position": 3,
                  "remarks": null,
                  "isPositive": false
              },
              {
                  "text": "严重",
                  "score": 4,
                  "position": 4,
                  "remarks": null,
                  "isPositive": false
              }
          ]
      },
      {
          "text": "必须反复洗手、点数",
          "weight": 1,
          "values": [
              {
                  "text": "无",
                  "score": 0,
                  "position": 0,
                  "remarks": null,
                  "isPositive": false
              },
              {
                  "text": "轻度",
                  "score": 1,
                  "position": 1,
                  "remarks": null,
                  "isPositive": false
              },
              {
                  "text": "中度",
                  "score": 2,
                  "position": 2,
                  "remarks": null,
                  "isPositive": false
              },
              {
                  "text": "相当重",
                  "score": 3,
                  "position": 3,
                  "remarks": null,
                  "isPositive": false
              },
              {
                  "text": "严重",
                  "score": 4,
                  "position": 4,
                  "remarks": null,
                  "isPositive": false
              }
          ]
      },
      {
          "text": "睡得不稳不深",
          "weight": 1,
          "values": [
              {
                  "text": "无",
                  "score": 0,
                  "position": 0,
                  "remarks": null,
                  "isPositive": false
              },
              {
                  "text": "轻度",
                  "score": 1,
                  "position": 1,
                  "remarks": null,
                  "isPositive": false
              },
              {
                  "text": "中度",
                  "score": 2,
                  "position": 2,
                  "remarks": null,
                  "isPositive": false
              },
              {
                  "text": "相当重",
                  "score": 3,
                  "position": 3,
                  "remarks": null,
                  "isPositive": false
              },
              {
                  "text": "严重",
                  "score": 4,
                  "position": 4,
                  "remarks": null,
                  "isPositive": false
              }
          ]
      },
      {
          "text": "有想摔坏或破坏东西的想法",
          "weight": 1,
          "values": [
              {
                  "text": "无",
                  "score": 0,
                  "position": 0,
                  "remarks": null,
                  "isPositive": false
              },
              {
                  "text": "轻度",
                  "score": 1,
                  "position": 1,
                  "remarks": null,
                  "isPositive": false
              },
              {
                  "text": "中度",
                  "score": 2,
                  "position": 2,
                  "remarks": null,
                  "isPositive": false
              },
              {
                  "text": "相当重",
                  "score": 3,
                  "position": 3,
                  "remarks": null,
                  "isPositive": false
              },
              {
                  "text": "严重",
                  "score": 4,
                  "position": 4,
                  "remarks": null,
                  "isPositive": false
              }
          ]
      },
      {
          "text": "有一些别人没有的想法",
          "weight": 1,
          "values": [
              {
                  "text": "无",
                  "score": 0,
                  "position": 0,
                  "remarks": null,
                  "isPositive": false
              },
              {
                  "text": "轻度",
                  "score": 1,
                  "position": 1,
                  "remarks": null,
                  "isPositive": false
              },
              {
                  "text": "中度",
                  "score": 2,
                  "position": 2,
                  "remarks": null,
                  "isPositive": false
              },
              {
                  "text": "相当重",
                  "score": 3,
                  "position": 3,
                  "remarks": null,
                  "isPositive": false
              },
              {
                  "text": "严重",
                  "score": 4,
                  "position": 4,
                  "remarks": null,
                  "isPositive": false
              }
          ]
      },
      {
          "text": "感到对别人神经过敏",
          "weight": 1,
          "values": [
              {
                  "text": "无",
                  "score": 0,
                  "position": 0,
                  "remarks": null,
                  "isPositive": false
              },
              {
                  "text": "轻度",
                  "score": 1,
                  "position": 1,
                  "remarks": null,
                  "isPositive": false
              },
              {
                  "text": "中度",
                  "score": 2,
                  "position": 2,
                  "remarks": null,
                  "isPositive": false
              },
              {
                  "text": "相当重",
                  "score": 3,
                  "position": 3,
                  "remarks": null,
                  "isPositive": false
              },
              {
                  "text": "严重",
                  "score": 4,
                  "position": 4,
                  "remarks": null,
                  "isPositive": false
              }
          ]
      },
      {
          "text": "在商店或电影院等人多的地方感到不自在",
          "weight": 1,
          "values": [
              {
                  "text": "无",
                  "score": 0,
                  "position": 0,
                  "remarks": null,
                  "isPositive": false
              },
              {
                  "text": "轻度",
                  "score": 1,
                  "position": 1,
                  "remarks": null,
                  "isPositive": false
              },
              {
                  "text": "中度",
                  "score": 2,
                  "position": 2,
                  "remarks": null,
                  "isPositive": false
              },
              {
                  "text": "相当重",
                  "score": 3,
                  "position": 3,
                  "remarks": null,
                  "isPositive": false
              },
              {
                  "text": "严重",
                  "score": 4,
                  "position": 4,
                  "remarks": null,
                  "isPositive": false
              }
          ]
      },
      {
          "text": "感到任何事情都很困难",
          "weight": 1,
          "values": [
              {
                  "text": "无",
                  "score": 0,
                  "position": 0,
                  "remarks": null,
                  "isPositive": false
              },
              {
                  "text": "轻度",
                  "score": 1,
                  "position": 1,
                  "remarks": null,
                  "isPositive": false
              },
              {
                  "text": "中度",
                  "score": 2,
                  "position": 2,
                  "remarks": null,
                  "isPositive": false
              },
              {
                  "text": "相当重",
                  "score": 3,
                  "position": 3,
                  "remarks": null,
                  "isPositive": false
              },
              {
                  "text": "严重",
                  "score": 4,
                  "position": 4,
                  "remarks": null,
                  "isPositive": false
              }
          ]
      },
      {
          "text": "一阵阵恐惧或惊恐",
          "weight": 1,
          "values": [
              {
                  "text": "无",
                  "score": 0,
                  "position": 0,
                  "remarks": null,
                  "isPositive": false
              },
              {
                  "text": "轻度",
                  "score": 1,
                  "position": 1,
                  "remarks": null,
                  "isPositive": false
              },
              {
                  "text": "中度",
                  "score": 2,
                  "position": 2,
                  "remarks": null,
                  "isPositive": false
              },
              {
                  "text": "相当重",
                  "score": 3,
                  "position": 3,
                  "remarks": null,
                  "isPositive": false
              },
              {
                  "text": "严重",
                  "score": 4,
                  "position": 4,
                  "remarks": null,
                  "isPositive": false
              }
          ]
      },
      {
          "text": "感到公共场合吃东西很不舒服",
          "weight": 1,
          "values": [
              {
                  "text": "无",
                  "score": 0,
                  "position": 0,
                  "remarks": null,
                  "isPositive": false
              },
              {
                  "text": "轻度",
                  "score": 1,
                  "position": 1,
                  "remarks": null,
                  "isPositive": false
              },
              {
                  "text": "中度",
                  "score": 2,
                  "position": 2,
                  "remarks": null,
                  "isPositive": false
              },
              {
                  "text": "相当重",
                  "score": 3,
                  "position": 3,
                  "remarks": null,
                  "isPositive": false
              },
              {
                  "text": "严重",
                  "score": 4,
                  "position": 4,
                  "remarks": null,
                  "isPositive": false
              }
          ]
      },
      {
          "text": "经常与人争论",
          "weight": 1,
          "values": [
              {
                  "text": "无",
                  "score": 0,
                  "position": 0,
                  "remarks": null,
                  "isPositive": false
              },
              {
                  "text": "轻度",
                  "score": 1,
                  "position": 1,
                  "remarks": null,
                  "isPositive": false
              },
              {
                  "text": "中度",
                  "score": 2,
                  "position": 2,
                  "remarks": null,
                  "isPositive": false
              },
              {
                  "text": "相当重",
                  "score": 3,
                  "position": 3,
                  "remarks": null,
                  "isPositive": false
              },
              {
                  "text": "严重",
                  "score": 4,
                  "position": 4,
                  "remarks": null,
                  "isPositive": false
              }
          ]
      },
      {
          "text": "单独一人时神经很紧张",
          "weight": 1,
          "values": [
              {
                  "text": "无",
                  "score": 0,
                  "position": 0,
                  "remarks": null,
                  "isPositive": false
              },
              {
                  "text": "轻度",
                  "score": 1,
                  "position": 1,
                  "remarks": null,
                  "isPositive": false
              },
              {
                  "text": "中度",
                  "score": 2,
                  "position": 2,
                  "remarks": null,
                  "isPositive": false
              },
              {
                  "text": "相当重",
                  "score": 3,
                  "position": 3,
                  "remarks": null,
                  "isPositive": false
              },
              {
                  "text": "严重",
                  "score": 4,
                  "position": 4,
                  "remarks": null,
                  "isPositive": false
              }
          ]
      },
      {
          "text": "别人对您的成绩没有做出恰当的评价",
          "weight": 1,
          "values": [
              {
                  "text": "无",
                  "score": 0,
                  "position": 0,
                  "remarks": null,
                  "isPositive": false
              },
              {
                  "text": "轻度",
                  "score": 1,
                  "position": 1,
                  "remarks": null,
                  "isPositive": false
              },
              {
                  "text": "中度",
                  "score": 2,
                  "position": 2,
                  "remarks": null,
                  "isPositive": false
              },
              {
                  "text": "相当重",
                  "score": 3,
                  "position": 3,
                  "remarks": null,
                  "isPositive": false
              },
              {
                  "text": "严重",
                  "score": 4,
                  "position": 4,
                  "remarks": null,
                  "isPositive": false
              }
          ]
      },
      {
          "text": "即使和别人在一起也感到孤单",
          "weight": 1,
          "values": [
              {
                  "text": "无",
                  "score": 0,
                  "position": 0,
                  "remarks": null,
                  "isPositive": false
              },
              {
                  "text": "轻度",
                  "score": 1,
                  "position": 1,
                  "remarks": null,
                  "isPositive": false
              },
              {
                  "text": "中度",
                  "score": 2,
                  "position": 2,
                  "remarks": null,
                  "isPositive": false
              },
              {
                  "text": "相当重",
                  "score": 3,
                  "position": 3,
                  "remarks": null,
                  "isPositive": false
              },
              {
                  "text": "严重",
                  "score": 4,
                  "position": 4,
                  "remarks": null,
                  "isPositive": false
              }
          ]
      },
      {
          "text": "感到坐立不安心神不定",
          "weight": 1,
          "values": [
              {
                  "text": "无",
                  "score": 0,
                  "position": 0,
                  "remarks": null,
                  "isPositive": false
              },
              {
                  "text": "轻度",
                  "score": 1,
                  "position": 1,
                  "remarks": null,
                  "isPositive": false
              },
              {
                  "text": "中度",
                  "score": 2,
                  "position": 2,
                  "remarks": null,
                  "isPositive": false
              },
              {
                  "text": "相当重",
                  "score": 3,
                  "position": 3,
                  "remarks": null,
                  "isPositive": false
              },
              {
                  "text": "严重",
                  "score": 4,
                  "position": 4,
                  "remarks": null,
                  "isPositive": false
              }
          ]
      },
      {
          "text": "感到自己没有什么价值",
          "weight": 1,
          "values": [
              {
                  "text": "无",
                  "score": 0,
                  "position": 0,
                  "remarks": null,
                  "isPositive": false
              },
              {
                  "text": "轻度",
                  "score": 1,
                  "position": 1,
                  "remarks": null,
                  "isPositive": false
              },
              {
                  "text": "中度",
                  "score": 2,
                  "position": 2,
                  "remarks": null,
                  "isPositive": false
              },
              {
                  "text": "相当重",
                  "score": 3,
                  "position": 3,
                  "remarks": null,
                  "isPositive": false
              },
              {
                  "text": "严重",
                  "score": 4,
                  "position": 4,
                  "remarks": null,
                  "isPositive": false
              }
          ]
      },
      {
          "text": "感到熟悉的东西变成陌生或不像是真的",
          "weight": 1,
          "values": [
              {
                  "text": "无",
                  "score": 0,
                  "position": 0,
                  "remarks": null,
                  "isPositive": false
              },
              {
                  "text": "轻度",
                  "score": 1,
                  "position": 1,
                  "remarks": null,
                  "isPositive": false
              },
              {
                  "text": "中度",
                  "score": 2,
                  "position": 2,
                  "remarks": null,
                  "isPositive": false
              },
              {
                  "text": "相当重",
                  "score": 3,
                  "position": 3,
                  "remarks": null,
                  "isPositive": false
              },
              {
                  "text": "严重",
                  "score": 4,
                  "position": 4,
                  "remarks": null,
                  "isPositive": false
              }
          ]
      },
      {
          "text": "大叫或摔东西",
          "weight": 1,
          "values": [
              {
                  "text": "无",
                  "score": 0,
                  "position": 0,
                  "remarks": null,
                  "isPositive": false
              },
              {
                  "text": "轻度",
                  "score": 1,
                  "position": 1,
                  "remarks": null,
                  "isPositive": false
              },
              {
                  "text": "中度",
                  "score": 2,
                  "position": 2,
                  "remarks": null,
                  "isPositive": false
              },
              {
                  "text": "相当重",
                  "score": 3,
                  "position": 3,
                  "remarks": null,
                  "isPositive": false
              },
              {
                  "text": "严重",
                  "score": 4,
                  "position": 4,
                  "remarks": null,
                  "isPositive": false
              }
          ]
      },
      {
          "text": "害怕会在公共场合晕倒",
          "weight": 1,
          "values": [
              {
                  "text": "无",
                  "score": 0,
                  "position": 0,
                  "remarks": null,
                  "isPositive": false
              },
              {
                  "text": "轻度",
                  "score": 1,
                  "position": 1,
                  "remarks": null,
                  "isPositive": false
              },
              {
                  "text": "中度",
                  "score": 2,
                  "position": 2,
                  "remarks": null,
                  "isPositive": false
              },
              {
                  "text": "相当重",
                  "score": 3,
                  "position": 3,
                  "remarks": null,
                  "isPositive": false
              },
              {
                  "text": "严重",
                  "score": 4,
                  "position": 4,
                  "remarks": null,
                  "isPositive": false
              }
          ]
      },
      {
          "text": "感到别人想占您的便宜",
          "weight": 1,
          "values": [
              {
                  "text": "无",
                  "score": 0,
                  "position": 0,
                  "remarks": null,
                  "isPositive": false
              },
              {
                  "text": "轻度",
                  "score": 1,
                  "position": 1,
                  "remarks": null,
                  "isPositive": false
              },
              {
                  "text": "中度",
                  "score": 2,
                  "position": 2,
                  "remarks": null,
                  "isPositive": false
              },
              {
                  "text": "相当重",
                  "score": 3,
                  "position": 3,
                  "remarks": null,
                  "isPositive": false
              },
              {
                  "text": "严重",
                  "score": 4,
                  "position": 4,
                  "remarks": null,
                  "isPositive": false
              }
          ]
      },
      {
          "text": "为一些有关性的想法而很苦恼",
          "weight": 1,
          "values": [
              {
                  "text": "无",
                  "score": 0,
                  "position": 0,
                  "remarks": null,
                  "isPositive": false
              },
              {
                  "text": "轻度",
                  "score": 1,
                  "position": 1,
                  "remarks": null,
                  "isPositive": false
              },
              {
                  "text": "中度",
                  "score": 2,
                  "position": 2,
                  "remarks": null,
                  "isPositive": false
              },
              {
                  "text": "相当重",
                  "score": 3,
                  "position": 3,
                  "remarks": null,
                  "isPositive": false
              },
              {
                  "text": "严重",
                  "score": 4,
                  "position": 4,
                  "remarks": null,
                  "isPositive": false
              }
          ]
      },
      {
          "text": "您认为应该因为自己的过错而受到惩罚",
          "weight": 1,
          "values": [
              {
                  "text": "无",
                  "score": 0,
                  "position": 0,
                  "remarks": null,
                  "isPositive": false
              },
              {
                  "text": "轻度",
                  "score": 1,
                  "position": 1,
                  "remarks": null,
                  "isPositive": false
              },
              {
                  "text": "中度",
                  "score": 2,
                  "position": 2,
                  "remarks": null,
                  "isPositive": false
              },
              {
                  "text": "相当重",
                  "score": 3,
                  "position": 3,
                  "remarks": null,
                  "isPositive": false
              },
              {
                  "text": "严重",
                  "score": 4,
                  "position": 4,
                  "remarks": null,
                  "isPositive": false
              }
          ]
      },
      {
          "text": "感到要很快把事情做完",
          "weight": 1,
          "values": [
              {
                  "text": "无",
                  "score": 0,
                  "position": 0,
                  "remarks": null,
                  "isPositive": false
              },
              {
                  "text": "轻度",
                  "score": 1,
                  "position": 1,
                  "remarks": null,
                  "isPositive": false
              },
              {
                  "text": "中度",
                  "score": 2,
                  "position": 2,
                  "remarks": null,
                  "isPositive": false
              },
              {
                  "text": "相当重",
                  "score": 3,
                  "position": 3,
                  "remarks": null,
                  "isPositive": false
              },
              {
                  "text": "严重",
                  "score": 4,
                  "position": 4,
                  "remarks": null,
                  "isPositive": false
              }
          ]
      },
      {
          "text": "感到自己的身体有严重问题",
          "weight": 1,
          "values": [
              {
                  "text": "无",
                  "score": 0,
                  "position": 0,
                  "remarks": null,
                  "isPositive": false
              },
              {
                  "text": "轻度",
                  "score": 1,
                  "position": 1,
                  "remarks": null,
                  "isPositive": false
              },
              {
                  "text": "中度",
                  "score": 2,
                  "position": 2,
                  "remarks": null,
                  "isPositive": false
              },
              {
                  "text": "相当重",
                  "score": 3,
                  "position": 3,
                  "remarks": null,
                  "isPositive": false
              },
              {
                  "text": "严重",
                  "score": 4,
                  "position": 4,
                  "remarks": null,
                  "isPositive": false
              }
          ]
      },
      {
          "text": "从未感到和其他人很亲近",
          "weight": 1,
          "values": [
              {
                  "text": "无",
                  "score": 0,
                  "position": 0,
                  "remarks": null,
                  "isPositive": false
              },
              {
                  "text": "轻度",
                  "score": 1,
                  "position": 1,
                  "remarks": null,
                  "isPositive": false
              },
              {
                  "text": "中度",
                  "score": 2,
                  "position": 2,
                  "remarks": null,
                  "isPositive": false
              },
              {
                  "text": "相当重",
                  "score": 3,
                  "position": 3,
                  "remarks": null,
                  "isPositive": false
              },
              {
                  "text": "严重",
                  "score": 4,
                  "position": 4,
                  "remarks": null,
                  "isPositive": false
              }
          ]
      },
      {
          "text": "感到自己有罪",
          "weight": 1,
          "values": [
              {
                  "text": "无",
                  "score": 0,
                  "position": 0,
                  "remarks": null,
                  "isPositive": false
              },
              {
                  "text": "轻度",
                  "score": 1,
                  "position": 1,
                  "remarks": null,
                  "isPositive": false
              },
              {
                  "text": "中度",
                  "score": 2,
                  "position": 2,
                  "remarks": null,
                  "isPositive": false
              },
              {
                  "text": "相当重",
                  "score": 3,
                  "position": 3,
                  "remarks": null,
                  "isPositive": false
              },
              {
                  "text": "严重",
                  "score": 4,
                  "position": 4,
                  "remarks": null,
                  "isPositive": false
              }
          ]
      },
      {
          "text": "感到自己的脑子有毛病",
          "weight": 1,
          "values": [
              {
                  "text": "无",
                  "score": 0,
                  "position": 0,
                  "remarks": null,
                  "isPositive": false
              },
              {
                  "text": "轻度",
                  "score": 1,
                  "position": 1,
                  "remarks": null,
                  "isPositive": false
              },
              {
                  "text": "中度",
                  "score": 2,
                  "position": 2,
                  "remarks": null,
                  "isPositive": false
              },
              {
                  "text": "相当重",
                  "score": 3,
                  "position": 3,
                  "remarks": null,
                  "isPositive": false
              },
              {
                  "text": "严重",
                  "score": 4,
                  "position": 4,
                  "remarks": null,
                  "isPositive": false
              }
          ]
      }
  ],
  "evaluations": [
      {
          "min": 400,
          "max": 500,
          "text": "总分",
          "isPositive": null,
          "desc": null
      }
  ],
  "state": 1,
  "userId": 8,
  "createTime": 1502881223591,
  "version": 3,
  "mobileShowStyle": 2,
  "webShowStyle": 1,
  "remarks": "SCL-90的每一个项目均采用5级评分制，具体如下： （1）没有：自觉无该项问题； （2）很轻，自觉有该项症状，但对被试者并无实际影响，或者影响轻微； （3）中度：自觉有该项症状，对被试者有一定影响； （4）偏重：自觉有该项症状，对被试者有相当程度的影响； （5）严重：自觉该症状的频度和强度都十分严重，对被试者的影响严重。 这里的“影响”包括症状所致的痛苦和烦恼，也包括症状造成的心理社会功能损害。“轻、中、重”的具体定义，由被试者自己体会，不必做硬性规定。 评定的时间，是“现在”或者是“最近一个星期”的实际感觉。",
  "doctorName": "李卫晖",
  "orderMasterId": 2388,
  "pluginConfigs": [
      {
          "name": "MultiItemPlugin",
          "data": "[{\"name\":\"躯体化\",\"desc\":\"\",\"ranges\":[{\"start\":0,\"end\":\"1\"},{\"start\":3,\"end\":\"4\"},{\"start\":11,\"end\":\"12\"},{\"start\":26,\"end\":\"27\"},{\"start\":39,\"end\":\"40\"},{\"start\":41,\"end\":\"42\"},{\"start\":47,\"end\":\"48\"},{\"start\":48,\"end\":\"49\"},{\"start\":51,\"end\":\"52\"},{\"start\":52,\"end\":\"53\"},{\"start\":55,\"end\":\"56\"},{\"start\":57,\"end\":\"58\"}],\"evaluations\":[{\"min\":0,\"max\":0,\"text\":\"无\",\"isPositive\":false,\"desc\":\"自觉并无该项症状\"},{\"min\":1,\"max\":12,\"text\":\"轻度\",\"isPositive\":false,\"desc\":\"自觉有该项症状，但对你并无实际影响或影响轻微\"},{\"min\":13,\"max\":24,\"text\":\"中度\",\"isPositive\":false,\"desc\":\"自觉有该项症状，对你有一定影响\"},{\"min\":25,\"max\":36,\"text\":\"相当重\",\"isPositive\":false,\"desc\":\"自觉有该项症状，对你有相当程度的影响\"},{\"min\":37,\"max\":48,\"text\":\"严重\",\"isPositive\":false,\"desc\":\"自觉该症状的频度和强度都十分严重，对你的影响严重\"}]},{\"name\":\"强迫症状\",\"desc\":\"\",\"ranges\":[{\"start\":2,\"end\":\"3\"},{\"start\":8,\"end\":\"9\"},{\"start\":9,\"end\":\"10\"},{\"start\":27,\"end\":\"28\"},{\"start\":37,\"end\":\"38\"},{\"start\":44,\"end\":\"45\"},{\"start\":45,\"end\":\"46\"},{\"start\":50,\"end\":\"51\"},{\"start\":54,\"end\":\"55\"},{\"start\":64,\"end\":\"65\"}],\"evaluations\":[{\"min\":0,\"max\":0,\"text\":\"无\",\"isPositive\":false,\"desc\":\"自觉并无该项症状\"},{\"min\":1,\"max\":10,\"text\":\"轻度\",\"isPositive\":false,\"desc\":\"自觉有该项症状，但对你并无实际影响或影响轻微\"},{\"min\":11,\"max\":20,\"text\":\"中度\",\"isPositive\":false,\"desc\":\"自觉有该项症状，对你有一定影响\"},{\"min\":21,\"max\":30,\"text\":\"相当重\",\"isPositive\":false,\"desc\":\"自觉有该项症状，对你有相当程度的影响\"},{\"min\":31,\"max\":40,\"text\":\"严重\",\"isPositive\":false,\"desc\":\"自觉该症状的频度和强度都十分严重，对你的影响严重\"}]},{\"name\":\"人际关系敏感\",\"desc\":\"\",\"ranges\":[{\"start\":5,\"end\":\"6\"},{\"start\":20,\"end\":\"21\"},{\"start\":33,\"end\":\"34\"},{\"start\":35,\"end\":\"36\"},{\"start\":36,\"end\":\"37\"},{\"start\":40,\"end\":\"41\"},{\"start\":60,\"end\":\"61\"},{\"start\":68,\"end\":\"69\"},{\"start\":72,\"end\":\"73\"}],\"evaluations\":[{\"min\":0,\"max\":0,\"text\":\"无\",\"isPositive\":false,\"desc\":\"自觉并无该项症状\"},{\"min\":1,\"max\":9,\"text\":\"轻度\",\"isPositive\":false,\"desc\":\"自觉有该项症状，但对你并无实际影响或影响轻微\"},{\"min\":10,\"max\":18,\"text\":\"中度\",\"isPositive\":false,\"desc\":\"自觉有该项症状，对你有一定影响\"},{\"min\":19,\"max\":27,\"text\":\"相当重\",\"isPositive\":false,\"desc\":\"自觉有该项症状，对你有相当程度的影响\"},{\"min\":28,\"max\":36,\"text\":\"严重\",\"isPositive\":false,\"desc\":\"自觉该症状的频度和强度都十分严重，对你的影响严重\"}]},{\"name\":\"抑郁\",\"desc\":\"\",\"ranges\":[{\"start\":4,\"end\":\"5\"},{\"start\":13,\"end\":\"14\"},{\"start\":14,\"end\":\"15\"},{\"start\":19,\"end\":\"20\"},{\"start\":21,\"end\":\"22\"},{\"start\":25,\"end\":\"26\"},{\"start\":28,\"end\":\"29\"},{\"start\":29,\"end\":\"30\"},{\"start\":30,\"end\":\"31\"},{\"start\":31,\"end\":\"32\"},{\"start\":53,\"end\":\"54\"},{\"start\":70,\"end\":\"71\"},{\"start\":78,\"end\":\"79\"}],\"evaluations\":[{\"min\":0,\"max\":0,\"text\":\"无\",\"isPositive\":false,\"desc\":\"自觉并无该项症状\"},{\"min\":1,\"max\":13,\"text\":\"轻度\",\"isPositive\":false,\"desc\":\"自觉有该项症状，但对你并无实际影响或影响轻微\"},{\"min\":14,\"max\":26,\"text\":\"中度\",\"isPositive\":false,\"desc\":\"自觉有该项症状，对你有一定影响\"},{\"min\":27,\"max\":39,\"text\":\"相当重\",\"isPositive\":false,\"desc\":\"自觉有该项症状，对你有相当程度的影响\"},{\"min\":40,\"max\":52,\"text\":\"严重\",\"isPositive\":false,\"desc\":\"自觉该症状的频度和强度都十分严重，对你的影响严重\"}]},{\"name\":\"焦虑\",\"desc\":\"\",\"ranges\":[{\"start\":1,\"end\":\"2\"},{\"start\":16,\"end\":\"17\"},{\"start\":22,\"end\":\"23\"},{\"start\":32,\"end\":\"33\"},{\"start\":38,\"end\":\"39\"},{\"start\":56,\"end\":\"57\"},{\"start\":71,\"end\":\"72\"},{\"start\":77,\"end\":\"78\"},{\"start\":79,\"end\":\"80\"},{\"start\":85,\"end\":\"86\"}],\"evaluations\":[{\"min\":0,\"max\":0,\"text\":\"无\",\"isPositive\":false,\"desc\":\"自觉并无该项症状\"},{\"min\":1,\"max\":10,\"text\":\"轻度\",\"isPositive\":false,\"desc\":\"自觉有该项症状，但对你并无实际影响或影响轻微\"},{\"min\":11,\"max\":20,\"text\":\"中度\",\"isPositive\":false,\"desc\":\"自觉有该项症状，对你有一定影响\"},{\"min\":21,\"max\":30,\"text\":\"相当重\",\"isPositive\":false,\"desc\":\"自觉有该项症状，对你有相当程度的影响\"},{\"min\":31,\"max\":40,\"text\":\"严重\",\"isPositive\":false,\"desc\":\"自觉该症状的频度和强度都十分严重，对你的影响严重\"}]},{\"name\":\"敌对\",\"desc\":\"\",\"ranges\":[{\"start\":10,\"end\":\"11\"},{\"start\":23,\"end\":\"24\"},{\"start\":62,\"end\":\"63\"},{\"start\":66,\"end\":\"67\"},{\"start\":73,\"end\":\"74\"},{\"start\":80,\"end\":\"81\"}],\"evaluations\":[{\"min\":0,\"max\":0,\"text\":\"无\",\"isPositive\":false,\"desc\":\"自觉并无该项症状\"},{\"min\":1,\"max\":6,\"text\":\"轻度\",\"isPositive\":false,\"desc\":\"自觉有该项症状，但对你并无实际影响或影响轻微\"},{\"min\":7,\"max\":12,\"text\":\"中度\",\"isPositive\":false,\"desc\":\"自觉有该项症状，对你有一定影响\"},{\"min\":13,\"max\":18,\"text\":\"相当重\",\"isPositive\":false,\"desc\":\"自觉有该项症状，对你有相当程度的影响\"},{\"min\":19,\"max\":24,\"text\":\"严重\",\"isPositive\":false,\"desc\":\"自觉该症状的频度和强度都十分严重，对你的影响严重\"}]},{\"name\":\"恐怖\",\"desc\":\"\",\"ranges\":[{\"start\":12,\"end\":\"13\"},{\"start\":24,\"end\":\"25\"},{\"start\":46,\"end\":\"47\"},{\"start\":49,\"end\":\"50\"},{\"start\":69,\"end\":\"70\"},{\"start\":74,\"end\":\"75\"},{\"start\":81,\"end\":\"82\"}],\"evaluations\":[{\"min\":0,\"max\":0,\"text\":\"无\",\"isPositive\":false,\"desc\":\"自觉并无该项症状\"},{\"min\":1,\"max\":7,\"text\":\"轻度\",\"isPositive\":false,\"desc\":\"自觉有该项症状，但对你并无实际影响或影响轻微\"},{\"min\":8,\"max\":14,\"text\":\"中度\",\"isPositive\":false,\"desc\":\"自觉有该项症状，对你有一定影响\"},{\"min\":15,\"max\":21,\"text\":\"相当重\",\"isPositive\":false,\"desc\":\"自觉有该项症状，对你有相当程度的影响\"},{\"min\":22,\"max\":28,\"text\":\"严重\",\"isPositive\":false,\"desc\":\"自觉该症状的频度和强度都十分严重，对你的影响严重\"}]},{\"name\":\"偏执\",\"desc\":\"\",\"ranges\":[{\"start\":7,\"end\":\"8\"},{\"start\":17,\"end\":\"18\"},{\"start\":42,\"end\":\"43\"},{\"start\":67,\"end\":\"68\"},{\"start\":75,\"end\":\"76\"},{\"start\":82,\"end\":\"83\"}],\"evaluations\":[{\"min\":0,\"max\":0,\"text\":\"无\",\"isPositive\":false,\"desc\":\"自觉并无该项症状\"},{\"min\":1,\"max\":6,\"text\":\"轻度\",\"isPositive\":false,\"desc\":\"自觉有该项症状，但对你并无实际影响或影响轻微\"},{\"min\":7,\"max\":12,\"text\":\"中度\",\"isPositive\":false,\"desc\":\"自觉有该项症状，对你有一定影响\"},{\"min\":13,\"max\":18,\"text\":\"相当重\",\"isPositive\":false,\"desc\":\"自觉有该项症状，对你有相当程度的影响\"},{\"min\":19,\"max\":24,\"text\":\"严重\",\"isPositive\":false,\"desc\":\"自觉该症状的频度和强度都十分严重，对你的影响严重\"}]},{\"name\":\"精神病性\",\"desc\":\"\",\"ranges\":[{\"start\":6,\"end\":\"7\"},{\"start\":15,\"end\":\"16\"},{\"start\":34,\"end\":\"35\"},{\"start\":61,\"end\":\"62\"},{\"start\":76,\"end\":\"77\"},{\"start\":83,\"end\":\"84\"},{\"start\":84,\"end\":\"85\"},{\"start\":86,\"end\":\"87\"},{\"start\":87,\"end\":\"88\"},{\"start\":89,\"end\":\"90\"}],\"evaluations\":[{\"min\":0,\"max\":0,\"text\":\"无\",\"isPositive\":false,\"desc\":\"自觉并无该项症状\"},{\"min\":1,\"max\":10,\"text\":\"轻度\",\"isPositive\":false,\"desc\":\"自觉有该项症状，但对你并无实际影响或影响轻微\"},{\"min\":11,\"max\":20,\"text\":\"中度\",\"isPositive\":false,\"desc\":\"自觉有该项症状，对你有一定影响\"},{\"min\":21,\"max\":30,\"text\":\"相当重\",\"isPositive\":false,\"desc\":\"自觉有该项症状，对你有相当程度的影响\"},{\"min\":31,\"max\":40,\"text\":\"严重\",\"isPositive\":false,\"desc\":\"自觉该症状的频度和强度都十分严重，对你的影响严重\"}]},{\"name\":\"其他\",\"desc\":\"\",\"ranges\":[{\"start\":18,\"end\":\"19\"},{\"start\":43,\"end\":\"44\"},{\"start\":58,\"end\":\"59\"},{\"start\":59,\"end\":\"60\"},{\"start\":63,\"end\":\"64\"},{\"start\":65,\"end\":\"66\"},{\"start\":88,\"end\":\"89\"}],\"evaluations\":[{\"min\":0,\"max\":0,\"text\":\"无\",\"isPositive\":false,\"desc\":\"自觉并无该项症状\"},{\"min\":1,\"max\":7,\"text\":\"轻度\",\"isPositive\":false,\"desc\":\"自觉有该项症状，但对你并无实际影响或影响轻微\"},{\"min\":8,\"max\":14,\"text\":\"中度\",\"isPositive\":false,\"desc\":\"自觉有该项症状，对你有一定影响\"},{\"min\":15,\"max\":21,\"text\":\"相当重\",\"isPositive\":false,\"desc\":\"自觉有该项症状，对你有相当程度的影响\"},{\"min\":22,\"max\":28,\"text\":\"严重\",\"isPositive\":false,\"desc\":\"自觉该症状的频度和强度都十分严重，对你的影响严重\"}]}]"
      }
  ],
  "latestVersionFlag": 1,
  "orderMasterName": "精神科C类量表测查--症状自评量表"
}

export const SCALE_SAS = {
  "id": "59354bce48676f07ec4f2f77",
  "name": "焦虑自评量表SAS",
  "group": null,
  "isStandard": true,
  "headers": [
      {
          "text": "没有或很少时间",
          "score": 1.25,
          "position": 0,
          "remarks": null,
          "isPositive": false
      },
      {
          "text": "少部分时间",
          "score": 2.5,
          "position": 1,
          "remarks": null,
          "isPositive": false
      },
      {
          "text": "相当多时间",
          "score": 3.75,
          "position": 2,
          "remarks": null,
          "isPositive": false
      },
      {
          "text": "绝大部分或全部时间",
          "score": 5,
          "position": 3,
          "remarks": null,
          "isPositive": false
      }
  ],
  "items": [
      {
          "text": "我觉得比平常容易紧张和着急",
          "weight": 1,
          "values": [
              {
                  "text": "没有或很少时间",
                  "score": 1.25,
                  "position": 0,
                  "remarks": null,
                  "isPositive": false
              },
              {
                  "text": "少部分时间",
                  "score": 2.5,
                  "position": 1,
                  "remarks": null,
                  "isPositive": false
              },
              {
                  "text": "相当多时间",
                  "score": 3.75,
                  "position": 2,
                  "remarks": null,
                  "isPositive": false
              },
              {
                  "text": "绝大部分或全部时间",
                  "score": 5,
                  "position": 3,
                  "remarks": null,
                  "isPositive": false
              }
          ]
      },
      {
          "text": "我无缘无故地感到害怕",
          "weight": 1,
          "values": [
              {
                  "text": "没有或很少时间",
                  "score": 1.25,
                  "position": 0,
                  "remarks": null,
                  "isPositive": false
              },
              {
                  "text": "少部分时间",
                  "score": 2.5,
                  "position": 1,
                  "remarks": null,
                  "isPositive": false
              },
              {
                  "text": "相当多时间",
                  "score": 3.75,
                  "position": 2,
                  "remarks": null,
                  "isPositive": false
              },
              {
                  "text": "绝大部分或全部时间",
                  "score": 5,
                  "position": 3,
                  "remarks": null,
                  "isPositive": false
              }
          ]
      },
      {
          "text": "我容易心里烦乱或觉得惊恐",
          "weight": 1,
          "values": [
              {
                  "text": "没有或很少时间",
                  "score": 1.25,
                  "position": 0,
                  "remarks": null,
                  "isPositive": false
              },
              {
                  "text": "少部分时间",
                  "score": 2.5,
                  "position": 1,
                  "remarks": null,
                  "isPositive": false
              },
              {
                  "text": "相当多时间",
                  "score": 3.75,
                  "position": 2,
                  "remarks": null,
                  "isPositive": false
              },
              {
                  "text": "绝大部分或全部时间",
                  "score": 5,
                  "position": 3,
                  "remarks": null,
                  "isPositive": false
              }
          ]
      },
      {
          "text": "我觉得我可能将要发疯",
          "weight": 1,
          "values": [
              {
                  "text": "没有或很少时间",
                  "score": 1.25,
                  "position": 0,
                  "remarks": null,
                  "isPositive": false
              },
              {
                  "text": "少部分时间",
                  "score": 2.5,
                  "position": 1,
                  "remarks": null,
                  "isPositive": false
              },
              {
                  "text": "相当多时间",
                  "score": 3.75,
                  "position": 2,
                  "remarks": null,
                  "isPositive": false
              },
              {
                  "text": "绝大部分或全部时间",
                  "score": 5,
                  "position": 3,
                  "remarks": null,
                  "isPositive": false
              }
          ]
      },
      {
          "text": "我觉得一切都好，也不会发生什么不幸",
          "weight": 1,
          "values": [
              {
                  "text": "没有或很少时间",
                  "score": 5,
                  "position": 0,
                  "remarks": null,
                  "isPositive": false
              },
              {
                  "text": "少部分时间",
                  "score": 3.75,
                  "position": 1,
                  "remarks": null,
                  "isPositive": false
              },
              {
                  "text": "相当多时间",
                  "score": 2.5,
                  "position": 2,
                  "remarks": null,
                  "isPositive": false
              },
              {
                  "text": "绝大部分或全部时间",
                  "score": 1.25,
                  "position": 3,
                  "remarks": null,
                  "isPositive": false
              }
          ]
      },
      {
          "text": "我手脚发抖打颤",
          "weight": 1,
          "values": [
              {
                  "text": "没有或很少时间",
                  "score": 1.25,
                  "position": 0,
                  "remarks": null,
                  "isPositive": false
              },
              {
                  "text": "少部分时间",
                  "score": 2.5,
                  "position": 1,
                  "remarks": null,
                  "isPositive": false
              },
              {
                  "text": "相当多时间",
                  "score": 3.75,
                  "position": 2,
                  "remarks": null,
                  "isPositive": false
              },
              {
                  "text": "绝大部分或全部时间",
                  "score": 5,
                  "position": 3,
                  "remarks": null,
                  "isPositive": false
              }
          ]
      },
      {
          "text": "我因为头痛颈痛和背痛而苦恼",
          "weight": 1,
          "values": [
              {
                  "text": "没有或很少时间",
                  "score": 1.25,
                  "position": 0,
                  "remarks": null,
                  "isPositive": false
              },
              {
                  "text": "少部分时间",
                  "score": 2.5,
                  "position": 1,
                  "remarks": null,
                  "isPositive": false
              },
              {
                  "text": "相当多时间",
                  "score": 3.75,
                  "position": 2,
                  "remarks": null,
                  "isPositive": false
              },
              {
                  "text": "绝大部分或全部时间",
                  "score": 5,
                  "position": 3,
                  "remarks": null,
                  "isPositive": false
              }
          ]
      },
      {
          "text": "我感觉容易衰弱和疲乏",
          "weight": 1,
          "values": [
              {
                  "text": "没有或很少时间",
                  "score": 1.25,
                  "position": 0,
                  "remarks": null,
                  "isPositive": false
              },
              {
                  "text": "少部分时间",
                  "score": 2.5,
                  "position": 1,
                  "remarks": null,
                  "isPositive": false
              },
              {
                  "text": "相当多时间",
                  "score": 3.75,
                  "position": 2,
                  "remarks": null,
                  "isPositive": false
              },
              {
                  "text": "绝大部分或全部时间",
                  "score": 5,
                  "position": 3,
                  "remarks": null,
                  "isPositive": false
              }
          ]
      },
      {
          "text": "我觉得心平气和，并且容易安静坐着",
          "weight": 1,
          "values": [
              {
                  "text": "没有或很少时间",
                  "score": 5,
                  "position": 0,
                  "remarks": null,
                  "isPositive": false
              },
              {
                  "text": "少部分时间",
                  "score": 3.75,
                  "position": 1,
                  "remarks": null,
                  "isPositive": false
              },
              {
                  "text": "相当多时间",
                  "score": 2.5,
                  "position": 2,
                  "remarks": null,
                  "isPositive": false
              },
              {
                  "text": "绝大部分或全部时间",
                  "score": 1.25,
                  "position": 3,
                  "remarks": null,
                  "isPositive": false
              }
          ]
      },
      {
          "text": "我觉得心跳得很快",
          "weight": 1,
          "values": [
              {
                  "text": "没有或很少时间",
                  "score": 1.25,
                  "position": 0,
                  "remarks": null,
                  "isPositive": false
              },
              {
                  "text": "少部分时间",
                  "score": 2.5,
                  "position": 1,
                  "remarks": null,
                  "isPositive": false
              },
              {
                  "text": "相当多时间",
                  "score": 3.75,
                  "position": 2,
                  "remarks": null,
                  "isPositive": false
              },
              {
                  "text": "绝大部分或全部时间",
                  "score": 5,
                  "position": 3,
                  "remarks": null,
                  "isPositive": false
              }
          ]
      },
      {
          "text": "我因为一阵阵头晕而苦恼",
          "weight": 1,
          "values": [
              {
                  "text": "没有或很少时间",
                  "score": 1.25,
                  "position": 0,
                  "remarks": null,
                  "isPositive": false
              },
              {
                  "text": "少部分时间",
                  "score": 2.5,
                  "position": 1,
                  "remarks": null,
                  "isPositive": false
              },
              {
                  "text": "相当多时间",
                  "score": 3.75,
                  "position": 2,
                  "remarks": null,
                  "isPositive": false
              },
              {
                  "text": "绝大部分或全部时间",
                  "score": 5,
                  "position": 3,
                  "remarks": null,
                  "isPositive": false
              }
          ]
      },
      {
          "text": "我有晕倒发作，或觉得要晕倒似的",
          "weight": 1,
          "values": [
              {
                  "text": "没有或很少时间",
                  "score": 1.25,
                  "position": 0,
                  "remarks": null,
                  "isPositive": false
              },
              {
                  "text": "少部分时间",
                  "score": 2.5,
                  "position": 1,
                  "remarks": null,
                  "isPositive": false
              },
              {
                  "text": "相当多时间",
                  "score": 3.75,
                  "position": 2,
                  "remarks": null,
                  "isPositive": false
              },
              {
                  "text": "绝大部分或全部时间",
                  "score": 5,
                  "position": 3,
                  "remarks": null,
                  "isPositive": false
              }
          ]
      },
      {
          "text": "我吸气呼气都感到很容易",
          "weight": 1,
          "values": [
              {
                  "text": "没有或很少时间",
                  "score": 5,
                  "position": 0,
                  "remarks": null,
                  "isPositive": false
              },
              {
                  "text": "少部分时间",
                  "score": 3.75,
                  "position": 1,
                  "remarks": null,
                  "isPositive": false
              },
              {
                  "text": "相当多时间",
                  "score": 2.5,
                  "position": 2,
                  "remarks": null,
                  "isPositive": false
              },
              {
                  "text": "绝大部分或全部时间",
                  "score": 1.25,
                  "position": 3,
                  "remarks": null,
                  "isPositive": false
              }
          ]
      },
      {
          "text": "我的手脚麻木和刺痛",
          "weight": 1,
          "values": [
              {
                  "text": "没有或很少时间",
                  "score": 1.25,
                  "position": 0,
                  "remarks": null,
                  "isPositive": false
              },
              {
                  "text": "少部分时间",
                  "score": 2.5,
                  "position": 1,
                  "remarks": null,
                  "isPositive": false
              },
              {
                  "text": "相当多时间",
                  "score": 3.75,
                  "position": 2,
                  "remarks": null,
                  "isPositive": false
              },
              {
                  "text": "绝大部分或全部时间",
                  "score": 5,
                  "position": 3,
                  "remarks": null,
                  "isPositive": false
              }
          ]
      },
      {
          "text": "我因为胃痛和消化不良而苦恼",
          "weight": 1,
          "values": [
              {
                  "text": "没有或很少时间",
                  "score": 1.25,
                  "position": 0,
                  "remarks": null,
                  "isPositive": false
              },
              {
                  "text": "少部分时间",
                  "score": 2.5,
                  "position": 1,
                  "remarks": null,
                  "isPositive": false
              },
              {
                  "text": "相当多时间",
                  "score": 3.75,
                  "position": 2,
                  "remarks": null,
                  "isPositive": false
              },
              {
                  "text": "绝大部分或全部时间",
                  "score": 5,
                  "position": 3,
                  "remarks": null,
                  "isPositive": false
              }
          ]
      },
      {
          "text": "我常常要小便",
          "weight": 1,
          "values": [
              {
                  "text": "没有或很少时间",
                  "score": 1.25,
                  "position": 0,
                  "remarks": null,
                  "isPositive": false
              },
              {
                  "text": "少部分时间",
                  "score": 2.5,
                  "position": 1,
                  "remarks": null,
                  "isPositive": false
              },
              {
                  "text": "相当多时间",
                  "score": 3.75,
                  "position": 2,
                  "remarks": null,
                  "isPositive": false
              },
              {
                  "text": "绝大部分或全部时间",
                  "score": 5,
                  "position": 3,
                  "remarks": null,
                  "isPositive": false
              }
          ]
      },
      {
          "text": "我的手常常是干燥温暖的",
          "weight": 1,
          "values": [
              {
                  "text": "没有或很少时间",
                  "score": 5,
                  "position": 0,
                  "remarks": null,
                  "isPositive": false
              },
              {
                  "text": "少部分时间",
                  "score": 3.75,
                  "position": 1,
                  "remarks": null,
                  "isPositive": false
              },
              {
                  "text": "相当多时间",
                  "score": 2.5,
                  "position": 2,
                  "remarks": null,
                  "isPositive": false
              },
              {
                  "text": "绝大部分或全部时间",
                  "score": 1.25,
                  "position": 3,
                  "remarks": null,
                  "isPositive": false
              }
          ]
      },
      {
          "text": "我脸红发热",
          "weight": 1,
          "values": [
              {
                  "text": "没有或很少时间",
                  "score": 1.25,
                  "position": 0,
                  "remarks": null,
                  "isPositive": false
              },
              {
                  "text": "少部分时间",
                  "score": 2.5,
                  "position": 1,
                  "remarks": null,
                  "isPositive": false
              },
              {
                  "text": "相当多时间",
                  "score": 3.75,
                  "position": 2,
                  "remarks": null,
                  "isPositive": false
              },
              {
                  "text": "绝大部分或全部时间",
                  "score": 5,
                  "position": 3,
                  "remarks": null,
                  "isPositive": false
              }
          ]
      },
      {
          "text": "我容易入睡并且一夜睡得很好",
          "weight": 1,
          "values": [
              {
                  "text": "没有或很少时间",
                  "score": 5,
                  "position": 0,
                  "remarks": null,
                  "isPositive": false
              },
              {
                  "text": "少部分时间",
                  "score": 3.75,
                  "position": 1,
                  "remarks": null,
                  "isPositive": false
              },
              {
                  "text": "相当多时间",
                  "score": 2.5,
                  "position": 2,
                  "remarks": null,
                  "isPositive": false
              },
              {
                  "text": "绝大部分或全部时间",
                  "score": 1.25,
                  "position": 3,
                  "remarks": null,
                  "isPositive": false
              }
          ]
      },
      {
          "text": "我做恶梦",
          "weight": 1,
          "values": [
              {
                  "text": "没有或很少时间",
                  "score": 1.25,
                  "position": 0,
                  "remarks": null,
                  "isPositive": false
              },
              {
                  "text": "少部分时间",
                  "score": 2.5,
                  "position": 1,
                  "remarks": null,
                  "isPositive": false
              },
              {
                  "text": "相当多时间",
                  "score": 3.75,
                  "position": 2,
                  "remarks": null,
                  "isPositive": false
              },
              {
                  "text": "绝大部分或全部时间",
                  "score": 5,
                  "position": 3,
                  "remarks": null,
                  "isPositive": false
              }
          ]
      }
  ],
  "evaluations": [
      {
          "min": 0,
          "max": 52,
          "text": "无焦虑",
          "isPositive": null,
          "desc": null
      },
      {
          "min": 53,
          "max": 62,
          "text": "轻度焦虑",
          "isPositive": null,
          "desc": null
      },
      {
          "min": 63,
          "max": 72,
          "text": "中度焦虑",
          "isPositive": null,
          "desc": null
      },
      {
          "min": 73,
          "max": 81,
          "text": "重度焦虑",
          "isPositive": null,
          "desc": null
      }
  ],
  "state": 1,
  "userId": 8,
  "createTime": 1496665038458,
  "version": 4,
  "mobileShowStyle": 2,
  "webShowStyle": 1,
  "remarks": "请根据您一周来的实际感觉填写",
  "doctorName": "李卫晖",
  "orderMasterId": 2185,
  "pluginConfigs": null,
  "latestVersionFlag": null,
  "orderMasterName": "精神科A类量表测--查宗(Zung)氏焦虑自评量表"
}

export const SCALE_SDS = {
  "id": "594c7db4b3cb1f000ce40eee",
  "name": "抑郁自评量表SDS",
  "group": null,
  "isStandard": true,
  "headers": [
      {
          "text": "没有或很少时间",
          "score": 5,
          "position": 0,
          "remarks": null,
          "isPositive": false
      },
      {
          "text": "少部分时间",
          "score": 3.75,
          "position": 1,
          "remarks": null,
          "isPositive": false
      },
      {
          "text": "相当多时间",
          "score": 2.5,
          "position": 2,
          "remarks": null,
          "isPositive": false
      },
      {
          "text": "绝大部分或全部时间",
          "score": 1.25,
          "position": 3,
          "remarks": null,
          "isPositive": false
      }
  ],
  "items": [
      {
          "text": "我觉得闷闷不乐，情绪低沉",
          "weight": 1,
          "values": [
              {
                  "text": "没有或很少时间",
                  "score": 1.25,
                  "position": 0,
                  "remarks": null,
                  "isPositive": false
              },
              {
                  "text": "少部分时间",
                  "score": 2.5,
                  "position": 1,
                  "remarks": null,
                  "isPositive": false
              },
              {
                  "text": "相当多时间",
                  "score": 3.75,
                  "position": 2,
                  "remarks": null,
                  "isPositive": false
              },
              {
                  "text": "绝大部分或全部时间",
                  "score": 5,
                  "position": 3,
                  "remarks": null,
                  "isPositive": false
              }
          ]
      },
      {
          "text": "我觉得一天中早晨最好",
          "weight": 1,
          "values": [
              {
                  "text": "没有或很少时间",
                  "score": 5,
                  "position": 0,
                  "remarks": null,
                  "isPositive": false
              },
              {
                  "text": "少部分时间",
                  "score": 3.75,
                  "position": 1,
                  "remarks": null,
                  "isPositive": false
              },
              {
                  "text": "相当多时间",
                  "score": 2.5,
                  "position": 2,
                  "remarks": null,
                  "isPositive": false
              },
              {
                  "text": "绝大部分或全部时间",
                  "score": 1.25,
                  "position": 3,
                  "remarks": null,
                  "isPositive": false
              }
          ]
      },
      {
          "text": "一阵阵哭出来或觉得想哭",
          "weight": 1,
          "values": [
              {
                  "text": "没有或很少时间",
                  "score": 1.25,
                  "position": 0,
                  "remarks": null,
                  "isPositive": false
              },
              {
                  "text": "少部分时间",
                  "score": 2.5,
                  "position": 1,
                  "remarks": null,
                  "isPositive": false
              },
              {
                  "text": "相当多时间",
                  "score": 3.75,
                  "position": 2,
                  "remarks": null,
                  "isPositive": false
              },
              {
                  "text": "绝大部分或全部时间",
                  "score": 5,
                  "position": 3,
                  "remarks": null,
                  "isPositive": false
              }
          ]
      },
      {
          "text": "我晚上睡眠不好",
          "weight": 1,
          "values": [
              {
                  "text": "没有或很少时间",
                  "score": 1.25,
                  "position": 0,
                  "remarks": null,
                  "isPositive": false
              },
              {
                  "text": "少部分时间",
                  "score": 2.5,
                  "position": 1,
                  "remarks": null,
                  "isPositive": false
              },
              {
                  "text": "相当多时间",
                  "score": 3.75,
                  "position": 2,
                  "remarks": null,
                  "isPositive": false
              },
              {
                  "text": "绝大部分或全部时间",
                  "score": 5,
                  "position": 3,
                  "remarks": null,
                  "isPositive": false
              }
          ]
      },
      {
          "text": "我吃得跟平常一样多",
          "weight": 1,
          "values": [
              {
                  "text": "没有或很少时间",
                  "score": 5,
                  "position": 0,
                  "remarks": null,
                  "isPositive": false
              },
              {
                  "text": "少部分时间",
                  "score": 3.75,
                  "position": 1,
                  "remarks": null,
                  "isPositive": false
              },
              {
                  "text": "相当多时间",
                  "score": 2.5,
                  "position": 2,
                  "remarks": null,
                  "isPositive": false
              },
              {
                  "text": "绝大部分或全部时间",
                  "score": 1.25,
                  "position": 3,
                  "remarks": null,
                  "isPositive": false
              }
          ]
      },
      {
          "text": "我与异性密切接触时和以往一样感到愉快",
          "weight": 1,
          "values": [
              {
                  "text": "没有或很少时间",
                  "score": 5,
                  "position": 0,
                  "remarks": null,
                  "isPositive": false
              },
              {
                  "text": "少部分时间",
                  "score": 3.75,
                  "position": 1,
                  "remarks": null,
                  "isPositive": false
              },
              {
                  "text": "相当多时间",
                  "score": 2.5,
                  "position": 2,
                  "remarks": null,
                  "isPositive": false
              },
              {
                  "text": "绝大部分或全部时间",
                  "score": 1.25,
                  "position": 3,
                  "remarks": null,
                  "isPositive": false
              }
          ]
      },
      {
          "text": "我发觉我的体重在下降",
          "weight": 1,
          "values": [
              {
                  "text": "没有或很少时间",
                  "score": 1.25,
                  "position": 0,
                  "remarks": null,
                  "isPositive": false
              },
              {
                  "text": "少部分时间",
                  "score": 2.5,
                  "position": 1,
                  "remarks": null,
                  "isPositive": false
              },
              {
                  "text": "相当多时间",
                  "score": 3.75,
                  "position": 2,
                  "remarks": null,
                  "isPositive": false
              },
              {
                  "text": "绝大部分或全部时间",
                  "score": 5,
                  "position": 3,
                  "remarks": null,
                  "isPositive": false
              }
          ]
      },
      {
          "text": "我有便秘的苦恼",
          "weight": 1,
          "values": [
              {
                  "text": "没有或很少时间",
                  "score": 1.25,
                  "position": 0,
                  "remarks": null,
                  "isPositive": false
              },
              {
                  "text": "少部分时间",
                  "score": 2.5,
                  "position": 1,
                  "remarks": null,
                  "isPositive": false
              },
              {
                  "text": "相当多时间",
                  "score": 3.75,
                  "position": 2,
                  "remarks": null,
                  "isPositive": false
              },
              {
                  "text": "绝大部分或全部时间",
                  "score": 5,
                  "position": 3,
                  "remarks": null,
                  "isPositive": false
              }
          ]
      },
      {
          "text": "心跳比平常快",
          "weight": 1,
          "values": [
              {
                  "text": "没有或很少时间",
                  "score": 1.25,
                  "position": 0,
                  "remarks": null,
                  "isPositive": false
              },
              {
                  "text": "少部分时间",
                  "score": 2.5,
                  "position": 1,
                  "remarks": null,
                  "isPositive": false
              },
              {
                  "text": "相当多时间",
                  "score": 3.75,
                  "position": 2,
                  "remarks": null,
                  "isPositive": false
              },
              {
                  "text": "绝大部分或全部时间",
                  "score": 5,
                  "position": 3,
                  "remarks": null,
                  "isPositive": false
              }
          ]
      },
      {
          "text": "我无缘无故地感到疲乏",
          "weight": 1,
          "values": [
              {
                  "text": "没有或很少时间",
                  "score": 1.25,
                  "position": 0,
                  "remarks": null,
                  "isPositive": false
              },
              {
                  "text": "少部分时间",
                  "score": 2.5,
                  "position": 1,
                  "remarks": null,
                  "isPositive": false
              },
              {
                  "text": "相当多时间",
                  "score": 3.75,
                  "position": 2,
                  "remarks": null,
                  "isPositive": false
              },
              {
                  "text": "绝大部分或全部时间",
                  "score": 5,
                  "position": 3,
                  "remarks": null,
                  "isPositive": false
              }
          ]
      },
      {
          "text": "我的头脑和平常一样清楚",
          "weight": 1,
          "values": [
              {
                  "text": "没有或很少时间",
                  "score": 5,
                  "position": 0,
                  "remarks": null,
                  "isPositive": false
              },
              {
                  "text": "少部分时间",
                  "score": 3.75,
                  "position": 1,
                  "remarks": null,
                  "isPositive": false
              },
              {
                  "text": "相当多时间",
                  "score": 2.5,
                  "position": 2,
                  "remarks": null,
                  "isPositive": false
              },
              {
                  "text": "绝大部分或全部时间",
                  "score": 1.25,
                  "position": 3,
                  "remarks": null,
                  "isPositive": false
              }
          ]
      },
      {
          "text": "我觉得经常做的事情并没有困难",
          "weight": 1,
          "values": [
              {
                  "text": "没有或很少时间",
                  "score": 5,
                  "position": 0,
                  "remarks": null,
                  "isPositive": false
              },
              {
                  "text": "少部分时间",
                  "score": 3.75,
                  "position": 1,
                  "remarks": null,
                  "isPositive": false
              },
              {
                  "text": "相当多时间",
                  "score": 2.5,
                  "position": 2,
                  "remarks": null,
                  "isPositive": false
              },
              {
                  "text": "绝大部分或全部时间",
                  "score": 1.25,
                  "position": 3,
                  "remarks": null,
                  "isPositive": false
              }
          ]
      },
      {
          "text": "我觉得不安而平静不下来",
          "weight": 1,
          "values": [
              {
                  "text": "没有或很少时间",
                  "score": 1.25,
                  "position": 0,
                  "remarks": null,
                  "isPositive": false
              },
              {
                  "text": "少部分时间",
                  "score": 2.5,
                  "position": 1,
                  "remarks": null,
                  "isPositive": false
              },
              {
                  "text": "相当多时间",
                  "score": 3.75,
                  "position": 2,
                  "remarks": null,
                  "isPositive": false
              },
              {
                  "text": "绝大部分或全部时间",
                  "score": 5,
                  "position": 3,
                  "remarks": null,
                  "isPositive": false
              }
          ]
      },
      {
          "text": "我对未来抱有希望",
          "weight": 1,
          "values": [
              {
                  "text": "没有或很少时间",
                  "score": 5,
                  "position": 0,
                  "remarks": null,
                  "isPositive": false
              },
              {
                  "text": "少部分时间",
                  "score": 3.75,
                  "position": 1,
                  "remarks": null,
                  "isPositive": false
              },
              {
                  "text": "相当多时间",
                  "score": 2.5,
                  "position": 2,
                  "remarks": null,
                  "isPositive": false
              },
              {
                  "text": "绝大部分或全部时间",
                  "score": 1.25,
                  "position": 3,
                  "remarks": null,
                  "isPositive": false
              }
          ]
      },
      {
          "text": "我比平常容易生气激动",
          "weight": 1,
          "values": [
              {
                  "text": "没有或很少时间",
                  "score": 1.25,
                  "position": 0,
                  "remarks": null,
                  "isPositive": false
              },
              {
                  "text": "少部分时间",
                  "score": 2.5,
                  "position": 1,
                  "remarks": null,
                  "isPositive": false
              },
              {
                  "text": "相当多时间",
                  "score": 3.75,
                  "position": 2,
                  "remarks": null,
                  "isPositive": false
              },
              {
                  "text": "绝大部分或全部时间",
                  "score": 5,
                  "position": 3,
                  "remarks": null,
                  "isPositive": false
              }
          ]
      },
      {
          "text": "我觉得做出决定是容易的",
          "weight": 1,
          "values": [
              {
                  "text": "没有或很少时间",
                  "score": 5,
                  "position": 0,
                  "remarks": null,
                  "isPositive": false
              },
              {
                  "text": "少部分时间",
                  "score": 3.75,
                  "position": 1,
                  "remarks": null,
                  "isPositive": false
              },
              {
                  "text": "相当多时间",
                  "score": 2.5,
                  "position": 2,
                  "remarks": null,
                  "isPositive": false
              },
              {
                  "text": "绝大部分或全部时间",
                  "score": 1.25,
                  "position": 3,
                  "remarks": null,
                  "isPositive": false
              }
          ]
      },
      {
          "text": "我觉得自己是个有用的人，有人需要我",
          "weight": 1,
          "values": [
              {
                  "text": "没有或很少时间",
                  "score": 5,
                  "position": 0,
                  "remarks": null,
                  "isPositive": false
              },
              {
                  "text": "少部分时间",
                  "score": 3.75,
                  "position": 1,
                  "remarks": null,
                  "isPositive": false
              },
              {
                  "text": "相当多时间",
                  "score": 2.5,
                  "position": 2,
                  "remarks": null,
                  "isPositive": false
              },
              {
                  "text": "绝大部分或全部时间",
                  "score": 1.25,
                  "position": 3,
                  "remarks": null,
                  "isPositive": false
              }
          ]
      },
      {
          "text": "我的生活过得很有意思",
          "weight": 1,
          "values": [
              {
                  "text": "没有或很少时间",
                  "score": 5,
                  "position": 0,
                  "remarks": null,
                  "isPositive": false
              },
              {
                  "text": "少部分时间",
                  "score": 3.75,
                  "position": 1,
                  "remarks": null,
                  "isPositive": false
              },
              {
                  "text": "相当多时间",
                  "score": 2.5,
                  "position": 2,
                  "remarks": null,
                  "isPositive": false
              },
              {
                  "text": "绝大部分或全部时间",
                  "score": 1.25,
                  "position": 3,
                  "remarks": null,
                  "isPositive": false
              }
          ]
      },
      {
          "text": "我认为如果我死了，别人会生活得更好",
          "weight": 1,
          "values": [
              {
                  "text": "没有或很少时间",
                  "score": 1.25,
                  "position": 0,
                  "remarks": null,
                  "isPositive": false
              },
              {
                  "text": "少部分时间",
                  "score": 2.5,
                  "position": 1,
                  "remarks": null,
                  "isPositive": false
              },
              {
                  "text": "相当多时间",
                  "score": 3.75,
                  "position": 2,
                  "remarks": null,
                  "isPositive": false
              },
              {
                  "text": "绝大部分或全部时间",
                  "score": 5,
                  "position": 3,
                  "remarks": null,
                  "isPositive": false
              }
          ]
      },
      {
          "text": "平常感兴趣的事我仍然感兴趣",
          "weight": 1,
          "values": [
              {
                  "text": "没有或很少时间",
                  "score": 5,
                  "position": 0,
                  "remarks": null,
                  "isPositive": false
              },
              {
                  "text": "少部分时间",
                  "score": 3.75,
                  "position": 1,
                  "remarks": null,
                  "isPositive": false
              },
              {
                  "text": "相当多时间",
                  "score": 2.5,
                  "position": 2,
                  "remarks": null,
                  "isPositive": false
              },
              {
                  "text": "绝大部分或全部时间",
                  "score": 1.25,
                  "position": 3,
                  "remarks": null,
                  "isPositive": false
              }
          ]
      }
  ],
  "evaluations": [
      {
          "min": 0,
          "max": 52,
          "text": "无抑郁",
          "isPositive": null,
          "desc": null
      },
      {
          "min": 53,
          "max": 62,
          "text": "轻度抑郁",
          "isPositive": null,
          "desc": null
      },
      {
          "min": 63,
          "max": 72,
          "text": "中度抑郁",
          "isPositive": null,
          "desc": null
      },
      {
          "min": 73,
          "max": 101,
          "text": "重度抑郁",
          "isPositive": null,
          "desc": null
      }
  ],
  "state": 1,
  "userId": 8,
  "createTime": 1498185140017,
  "version": 6,
  "mobileShowStyle": 2,
  "webShowStyle": 1,
  "remarks": "重要提示\n1.请严谨、仔细填写以下量表，评估结果是医生为你提供诊疗服务的重要参考\n2.随意或未按真实情况填写，可能会影响医生对您病情的正确判断\n3.量表的评估结果只做为医生医疗相关活动使用\n请根据您一周来的实际感觉填写",
  "doctorName": "李卫晖",
  "orderMasterId": 2186,
  "pluginConfigs": [
      {
          "name": "ItemGroupStatisticPlugin",
          "data": "{\"names\":[\"忧郁\",\"晨重晚轻\",\"易哭\",\"睡眠障碍\",\"食欲减退\",\"性兴趣减退\",\"体重减轻\",\"便秘\",\"心悸\",\"易倦\",\"思考困难\",\"能力减退\",\"不安\",\"绝望\",\"易激惹\",\"决断困难\",\"无用感\",\"生活空虚感\",\"无价值感\",\"兴趣丧失\"],\"groupConfigs\":[{\"name\":\"重度症状\",\"score\":5},{\"name\":\"中度症状\",\"score\":3.75},{\"name\":\"轻度症状\",\"score\":2.5},{\"name\":\"没有的症状\",\"score\":1.25}]}"
      }
  ],
  "latestVersionFlag": 1,
  "orderMasterName": "精神科A类量表测--查宗(Zung)氏抑郁自评量表"
}